{
  "dashboard": {
    "title": "Dashboard",
    "filters": {
      "dateFrom": "Fecha Desde",
      "dateTo": "Fecha Hasta",
      "client": "Cliente",
      "entities": "Entidades",
      "allClients": "Todos los Clientes",
      "allEntities": "Todas mis entidades/subentidades",
      "movementType": "Tipo de Movimiento",
      "allMovementTypes": "Todos",
      "searchPlaceholder": "Buscar...",
      "noResults": "No se encontraron resultados",
      "reset": "Limpiar Filtros",
      "removeFilter": "Quitar filtro"
    },
    "granularity": {
      "day": "Día",
      "week": "Semana",
      "month": "Mes",
      "quarter": "Trimestre",
      "year": "Año"
    },
    "admin": {
      "kpis": {
        "totalRevenue": "FACTURACIÓN TOTAL",
        "transportPart": "transporte",
        "expensesRepercutidosPart": "gastos repercutidos",
        "expensesNoRepercutidosPart": "no repercutidos",
        "profitMargin": "MARGEN DE GANANCIAS",
        "marginRatio": "Margen",
        "cancellationCosts": "COSTES DE CANCELACIÓN",
        "cancellationRatio": "de los transportes creados",
        "pendingIncidents": "INCIDENCIAS PENDIENTES",
        "claims": "Siniestros",
        "breakdowns": "Averías",
        "additionalExpenses": "GASTOS ADICIONALES",
        "repercutidos": "repercutidos",
        "noRepercutidos": "no repercutidos",
        "completedTransports": "TRANSPORTES REALIZADOS",
        "cancelledTransports": "TRANSPORTES CANCELADOS",
        "averageTicket": "TICKET MEDIO",
        "averageDistance": "DISTANCIA MEDIA X TRANSPORTE",
        "activeDrivers": "CONDUCTORES ACTIVOS"
      },
      "charts": {
        "revenueEvolutionTitle": "Facturación por periodo",
        "revenueEvolutionSubtitle": "Ingresos facturados vs Costes operativos reales y de conductor",
        "topClientsTitle": "Top clientes por facturación",
        "topClientsSubtitle": "Distribución de ingresos y rentabilidad por cliente",
        "additionalExpensesTitle": "Gastos adicionales por cliente",
        "additionalExpensesSubtitle": "Desglose comparativo de suplementos repercutidos al cliente frente a los no repercutidos",
        "series": {
          "invoiceTransport": "Facturación transporte",
          "expensesRepercutidos": "Gastos repercutidos",
          "totalCost": "Coste total",
          "expensesNoRepercutidos": "Gastos no repercutidos",
          "driverCost": "Coste conductor + seguro",
          "invoicing": "Facturación",
          "margin": "Margen",
          "transports": "Transportes",
          "repercutidos": "Repercutidos",
          "noRepercutidos": "No repercutidos"
        }
      }
    },
    "client": {
      "kpis": {
        "totalSpent": "GASTO TOTAL",
        "totalSpentNote": "Transporte + gastos repercutidos",
        "averageTicket": "TICKET MEDIO",
        "averageTicketNote": "Sobre transportes filtrados",
        "averageDistance": "DISTANCIA MEDIA",
        "averageDistanceNote": "Km medios por transporte",
        "completedTransports": "TOTAL TRANSPORTES",
        "completedTransportsNote": "Actividad del periodo",
        "additionalExpenses": "GASTOS ADICIONALES",
        "additionalExpensesNote": "Solo gastos repercutidos",
        "cancellationCosts": "COSTE CANCELACIONES",
        "cancellationRatio": "de los transportes creados",
        "cancelledTransports": "TRAYECTOS CANCELADOS",
        "pendingIncidents": "INCIDENCIAS PENDIENTES",
        "claims": "Siniestros",
        "breakdowns": "Averías"
      },
      "charts": {
        "expensesSummaryTitle": "Resumen de gastos",
        "expensesSummarySubtitle": "Evolución del importe total gastado y volumen de suplementos repercutidos",
        "series": {
          "totalAmount": "Importe total",
          "repercutidosCount": "Nº de gastos repercutidos",
          "repercutidosCountAxis": "Nº de gastos",
          "supplements": "Nº de gastos repercutidos"
        }
      }
    }
  },
  "invoiceConceptType": {
    "TRANSPORT": "Transporte",
    "FUEL": "Combustible",
    "FERRY": "Ferry",
    "CHARGING": "Carga",
    "ADDITIONAL_SERVICE": "Servicio adicional",
    "ADDITIONAL_COST": "Coste adicional",
    "ADJUSTMENT": "Ajuste",
    "BONUS": "Bonus",
    "PENALTY": "Penalización",
    "CANCELLATION": "Cancelación"
  },
  "common": {
    "email": "Email",
    "password": "Contraseña",
    "login": "LOGIN",
    "remember_me": "Recuérdame",
    "forgot_password": "¿Olvidaste contraseña?",
    "loading": "Cargando...",
    "loading_dots": "cargando ...",
    "filters": "FILTROS",
    "exportable": "EXPORTAR CSV",
    "textPlaceholder": "Escriba aquí...",
    "selectPlaceholder": "Seleccione...",
    "back": "ATRÁS",
    "newService": "NUEVO TRANSPORTE",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "copy": "Copiar",
    "save": "Guardar",
    "accept": "Aceptar",
    "yes": "Sí",
    "no": "No",
    "guideLabel": "Guía de formato",
    "templateLabel": "Archivo de plantilla",
    "uploadLabel": "Importar archivo",
    "actions": {
      "edit": "Editar",
      "view": "Ver",
      "delete": "Eliminar",
      "create": "Crear",
      "save": "Guardar",
      "cancel": "Cancelar"
    },
    "periodDays": {
      "15": "15 días",
      "30": "30 días",
      "45": "45 días",
      "60": "60 días",
      "75": "75 días",
      "90": "90 días"
    },
    "days": "días"
  },
  "paginator": {
    "itemsPerPageLabel": "Elementos por página:",
    "nextPageLabel": "Página siguiente",
    "previousPageLabel": "Página anterior",
    "firstPageLabel": "Primera página",
    "lastPageLabel": "Última página",
    "rangeLabel": {
      "empty": "0 de {{length}}",
      "range": "{{start}} - {{end}} de {{length}}"
    }
  },
  "cancellationAdjustmentType": {
    "PAY": "Pagar al conductor",
    "PENALTY": "Penalizar al conductor",
    "NO_PAY": "No pagar al conductor"
  },
  "budgetStatus": {
    "ACCEPTED": "Aceptado",
    "REJECTED": "Rechazado",
    "PENDING": "Pendiente",
    "CANCELLED": "Cancelado",
    "UNASSIGNED": "Anulado"
  },
  "login": {
    "title": "Iniciar Sesión",
    "email_required": "El email es requerido",
    "email_invalid": "Formato de email inválido",
    "password_required": "La contraseña es requerida",
    "password_min": "La contraseña debe tener al menos 6 caracteres",
    "signing_in": "Iniciando sesión...",
    "show_password": "Mostrar contraseña",
    "hide_password": "Ocultar contraseña",
    "credentials_error": "Contraseña o nombre de usuario incorrectos",
    "connection_error": "Error de conexión con el servidor. Inténtelo de nuevo más tarde",
    "forgot_email_label": "Email de recuperación",
    "forgot_send": "ENVIAR",
    "forgot_sending": "Enviando...",
    "forgot_success": "Se ha enviado un correo para restablecer tu contraseña",
    "forgot_error": "No se pudo enviar el correo. Inténtelo de nuevo",
    "forgot_back": "Volver al login",
    "reset_title": "Recuperar contraseña",
    "reset_new_password": "Nueva Contraseña",
    "reset_confirm_password": "Confirmar Contraseña",
    "reset_hint": "Al menos 8 caracteres, 1 mayúscula, 1 minúscula, 1 número y un símbolo.",
    "reset_send": "ENVIAR",
    "reset_sending": "Enviando...",
    "reset_success": "Tu contraseña ha sido restablecida correctamente",
    "reset_error": "No se pudo restablecer la contraseña. Inténtelo de nuevo",
    "reset_password_required": "La contraseña es requerida",
    "reset_password_pattern": "La contraseña no cumple los requisitos",
    "reset_password_mismatch": "Las contraseñas no coinciden"
  },
  "navigation": {
    "dashboard": "Dashboard",
    "users": "Usuarios",
    "clients": "Clientes",
    "client_group": "Grupo de clientes",
    "clients_list": "Clientes",
    "client_entity_users": "Usuarios de Entidad",
    "drivers": "Conductores",
    "transports": "Transportes",
    "create_transport": "Crear transporte",
    "transport_assignment": "Asignación transportes",
    "transport_history": "Gestión de transportes",
    "quality_info_management": "Gestión info calidad",
    "drivers_incidents": "Conductores e incidencias",
    "driver_regularizations": "Regularizaciones a conductores",
    "additional_expenses": "Gastos adicionales",
    "driver_invoice_emission": "Emisión de facturas a conductores",
    "driver_invoices": "Facturas conductores",
    "client_invoices": "Facturas clientes",
    "invoices": "Facturación",
    "notifications": "Notificaciones",
    "addresses": "Direcciones"
  },
  "construction": {
    "title": "Página en construcción"
  },
  "users": {
    "title": "Usuarios",
    "profileTittle": "Perfil de Usuario",
    "create-user": "Crear nuevo usuario",
    "edit-user": "Editar Usuario",
    "profile": {
      "upload-photo": "SUBIR FOTO",
      "delete": "ELIMINAR",
      "photo-upload-explanation": "Permite JPG, GIF o PNG. Tamaño max. 800Kb",
      "userName": "nombre inicio de sesión",
      "username": "Nombre de usuario",
      "name": "Nombre",
      "lastname": "Apellidos",
      "email": "Email",
      "password": "Contraseña",
      "password-hint": "Al menos 8 caracteres, 1 mayúscula, 1 minúscula, 1 número y un símbolo.",
      "gen-pass": "GENERAR CONTRASEÑA SEGURA",
      "role": "Rol",
      "status": "Estado",
      "ACTIVE": "Activo",
      "INACTIVE": "Inactivo",
      "PENDING": "Pendiente",
      "SUSPENDED": "Suspendido",
      "department": "Departamento",
      "USER": "Usuario",
      "ADMIN": "Administrador",
      "CLIENT_USER": "Cliente",
      "DRIVER": "Conductor",
      "save-changes": "GUARDAR CAMBIOS",
      "cancel": "CANCELAR",
      "SUPERADMIN": "Superadministrador",
      "OPERATIONS_MANAGER": "Responsable de operaciones",
      "SALES_MANAGER": "Responsable de ventas",
      "KAM": "KAM"
    },
    "list": {
      "photo": "Foto",
      "name": "Nombre",
      "lastname": "Apellidos",
      "email": "Email",
      "role": "Rol",
      "status": "Estado",
      "department": "Departamento",
      "actions": "Acciones",
      "searchPlaceholder": "Buscar",
      "filter": "Filtros",
      "filters": "Filtros",
      "create-user": "CREAR NUEVO USUARIO",
      "advancedFilters": "Filtros Avanzados",
      "all": "Todos",
      "active": "Activo",
      "inactive": "Inactivo",
      "admin": "Administración",
      "hr": "Recursos Humanos",
      "finance": "Finanzas",
      "dateFrom": "Fecha desde",
      "dateTo": "Fecha hasta",
      "clearFilters": "Limpiar filtros",
      "applyFilters": "Aplicar filtros",
      "exportCSV": "Exportar CSV"
    },
    "actions": {
      "edit": "Editar",
      "delete": "Eliminar"
    },
    "messages": {
      "delete_confirm": "¿Estás seguro de que deseas eliminar este usuario?",
      "delete_success": "Usuario eliminado correctamente",
      "delete_error": "Error al eliminar el usuario",
      "export_no_data": "No hay usuarios para exportar",
      "export_success": "Usuarios exportados correctamente",
      "export_error": "Error al exportar los usuarios"
    },
    "errors": {
      "password-weak": "La contraseña es demasiado débil",
      "password-invalid": "La contraseña debe tener al menos 8 caracteres, 1 mayúscula, 1 minúscula, 1 número y un símbolo.",
      "user-update-error": "Error al actualizar usuario",
      "user-create-error": "Error al crear usuario",
      "name-required": "El nombre es obligatorio",
      "lastname-required": "El apellido es obligatorio",
      "email-invalid": "Email inválido",
      "image-required": "La imagen es obligatoria",
      "role-required": "Debe seleccionar al menos un rol",
      "status-required": "Debe seleccionar el estado"
    },
    "success": {
      "user-updated": "Usuario actualizado correctamente",
      "user-created": "Usuario creado correctamente"
    }
  },
  "clients": {
    "title": "Clientes",
    "create-group-title": "Creación Grupo Cliente",
    "edit-group-title": "Edición Grupo Cliente",
    "create-client-title": "Crear/Editar Entidad",
    "create-group": {
      "name": "Nombre del grupo cliente",
      "country": "País",
      "assigned-admins": "Administradores asignados",
      "save": "Guardar cambios",
      "cancel": "Cancelar",
      "errors": {
        "name-required": "El nombre es requerido",
        "country-required": "El país es requerido"
      }
    },
    "create-client": {
      "upload-logo": "Subir Logo",
      "delete-logo": "Eliminar",
      "upload-logo-explanation": "Permite JPG, GIF o PNG. Máximo 800Kb",
      "subentity": "Es subentidad",
      "group": "Grupo de Cliente",
      "name": "Nombre",
      "client": "Cliente Principal",
      "entity": "Entidad",
      "id-eurotransport": "Identificador Eurotransportcar (PO)",
      "id-revel": "Identificador Revel",
      "billing-type": "Tipo de facturación",
      "billing-type-manual": "Manual",
      "billing-type-automatic": "Automático",
      "send-manual-invoice": "Emitir factura manual",
      "check-own-insurance": "Seguro propio",
      "check-at-risk": "En riesgo",
      "appointment-time": "Tiempo de espera para envío de cita (h)",
      "appointment-time-between": "Tiempo entre recordatorios de cita (h)",
      "department-incidences": "Departamento incidencias",
      "send-final-customer": "¿Enviar encuesta a cliente final?",
      "client-type": "Tipo de cliente",
      "client-type-1": "Tipo 1",
      "client-type-2": "Tipo 2",
      "client-origin": "Origen del cliente",
      "client-origin-1": "Origen 1",
      "client-origin-2": "Origen 2",
      "main-contact": "Persona de contacto principal",
      "main-contact-name": "Nombre",
      "main-contact-email": "Email",
      "main-contact-phone": "Teléfono",
      "email": "Email",
      "save-changes": "Guardar cambios",
      "cancel": "Cancelar",
      "contact-gral": "Contactos generales",
      "internal-protocol": "Protocolo interno",
      "contacts-requireds": "Ambos campos son obligatorios",
      "errors": {
        "name-required": "El nombre es requerido",
        "id-eurotransport-required": "El ID de Eurotransportcar es requerido",
        "id-revel-required": "El ID de Revel es requerido",
        "billing-type-required": "El tipo de facturación es requerido",
        "client-type-required": "El tipo de cliente es requerido",
        "client-origin-required": "El origen del cliente es requerido"
      },
      "movement-type": "Tipo de movimiento",
      "movement-type-1": "Movimiento 1",
      "movement-type-2": "Movimiento 2",
      "adjunt-type": "Tipo de adjunto",
      "adjunt-type-1": "Adjunto 1",
      "adjunt-type-2": "Adjunto 2",
      "application-moment": "Momento de aplicación",
      "application-moment-1": "Momento 1",
      "application-moment-2": "Momento 2",
      "main-client": "Cliente principal",
      "save": "Guardar",
      "doc_type": "Tipo de documento",
      "doc-type-1": "Documento 1",
      "doc-type-2": "Documento 2",
      "url": "URL",
      "archive-link": "Archivo/Link",
      "entity-reference": "Referencia de entidad",
      "document-type": "Tipo de documento",
      "document-code": "Nº de documento",
      "retention": "Retención",
      "company-name": "Razón social",
      "vat-type": "Tipo de IVA",
      "billing-address": "Dirección de facturación",
      "address-complement": "Compl. de dirección",
      "postal-code": "Código postal",
      "city": "Ciudad",
      "country": "País",
      "eurotransportcar-identifier": "Identificador Eurotransportcar",
      "revel-identifier": "Identificador Revel",
      "accounting-email": "Email contabilidad",
      "accounting-email-placeholder": "Escribe un email y pulsa Enter...",
      "accounting-phone": "Teléfono de contabilidad",
      "mark-as-favorite": "Marcar como favorito",
      "due-period": "Periodo de vencimiento",
      "add-account": "AÑADIR CUENTA",
      "id-ref": "REF. IDENTIDAD",
      "tax-id-dni": "CIF O DNI",
      "retention-percent": "RETENCIÓN (%)",
      "actions": "ACCIONES",
      "results-per-page": "Resultados por página",
      "cif": "CIF",
      "department": "Departamento",
      "fuel": "Combustible",
      "included-fuel": "Combustible incluido",
      "client-price": "Precio Cliente",
      "driver-price": "Precio Conductor % por Km",
      "ferry": "Ferry",
      "ferry-price": "Precio Ferry",
      "ev": "Vehículo eléctrico",
      "ev-client-price": "Precio Cliente por Km (EUR)",
      "ev-driver-price": "Precio Conductor por Km (EUR)",
      "additional": "Adicionales",
      "express-transport-percent": "Precio Transporte Exprés (%)",
      "stage-discount-percent": "Descuento por etapa adicional(%)",
      "km-bands": "Franjas de kilómetros",
      "km-from": "Desde (Km)",
      "km-to": "Hasta (Km)",
      "price-to-client": "Precio al cliente",
      "price-type": "Tipo de precio",
      "standard-price-eur": "Precio Standard (EUR)",
      "price-vu-lt-12": "Precio VU < 12m3",
      "price-vu-gt-12": "Precio VU > 12m3",
      "distance-interval": "Intervalo de distancia",
      "validate-add": "Validar y añadir",
      "save-price": "Guardar datos de precios",
      "save-prices-first": "Guarde los datos de precios antes de crear franjas de kilómetros",
      "km-overlap-error": "Los rangos de km no pueden solaparse, sin rangos NO definidos entre medio y la primera debe empezar en 0",
      "price_rules_saved_success": "Reglas de precios guardadas correctamente",
      "doc-type": "Tipo de documento",
      "cert_list": "Lista de certificados",
      "certs-created": "Lista de certificaciones creadas",
      "certs-assigned": "Certificaciones asignadas",
      "delete-certification-confirmation": "¿Está seguro de que desea eliminar esta certificación?",
      "choose-certification": "Elegir certificación",
      "certification-title": "Título de la certificación",
      "cert-question": "Pregunta",
      "question-placeholder": "¿Escribe tu pregunta aquí?",
      "answer": "Respuesta",
      "answer-placeholder": "Escribe la respuesta aquí",
      "add-answer": "Añadir respuesta",
      "add-question": "Añadir pregunta",
      "config": "Configuración",
      "attempts-per-week": "Intentos por semana",
      "available-new-drivers": "Disponible para nuevos conductores",
      "save-cert": "Guardar certificación",
      "action-details": "Detalles de la acción",
      "action-title": "Título de acción",
      "driver-payment": "Pago conductor",
      "departure": "Salida",
      "arrival": "Llegada",
      "both": "Ambas (Salida y Llegada)",
      "certification-config": "Configuración de certificación",
      "certification-name": "Nombre",
      "edit-certification": "EDITAR CERTIFICACIÓN",
      "select-certification": "SELECCIONAR CERTIFICACIÓN",
      "requires-certification": "Requiere certificación",
      "selected-by-default": "Seleccionado por defecto",
      "visible-to-driver": "Visible para el conductor",
      "requires-image-location": "Requiere imagen y localización",
      "requires-appoinment": "Requiere cita previa",
      "assign": "ASIGNAR",
      "protocolo-save": "Guardar protocolo",
      "protocol-delete-confirm-title": "¿Eliminar protocolo?",
      "protocol-delete-confirm-subtitle": "Esta acción no se puede deshacer. El protocolo será eliminado permanentemente.",
      "protocols-assigned": "Protocolos asignados",
      "protocols-templates": "Plantilla de protocolos",
      "intern-movement-type": "Tipo de movimiento interno",
      "schemas": "Plantillas",
      "protocols": "Protocolos",
      "type": "Tipo",
      "edit-options": "Editar opciones",
      "client-process": "Procedimiento de cliente",
      "simple-movement": "Movimiento simple",
      "pickup-to-final-customer": "Recogida a cliente final",
      "delivery-to-final-customer": "Entrega a cliente final",
      "pickup-and-delivery-to-final-customer": "Recogida y entrega a cliente final",
      "with-stopover": "Con escala",
      "single-check": "Chequeo único",
      "multi-check": "Chequeo múltiple",
      "image": "Imagen",
      "both-departure-both": "Ambos (salida y llegada)",
      "pricing-type-fixed": "Fijo",
      "pricing-type-per-km": "Por kilómetro",
      "description": "Descripción",
      "additional-services": "Plantillas de servicios adicionales",
      "additional-services-assigned": "Servicios adicionales asignados",
      "other": "Otro"
    },
    "list": {
      "clients_group": "Grupos de Clientes",
      "clients_list": "Lista de Clientes",
      "group_name": "Nombre del Grupo",
      "logo": "Logotipo",
      "name": "Nombre",
      "group": "Grupo",
      "cif": "CIF",
      "registration_date": "Fecha Alta",
      "department-name": "Departamento",
      "country-name": "País",
      "tags": "Tags",
      "entity": "Entidad",
      "actions": "Acciones",
      "searchPlaceholder": "Buscar...",
      "create-client": "CREAR NUEVO CLIENTE",
      "create-group": "CREAR NUEVO GRUPO",
      "group_filter": "Grupo",
      "cif_filter": "CIF",
      "cif_placeholder": "Escribe aquí...",
      "registration_date_filter": "Fecha de alta",
      "department_filter": "Departamento",
      "tags_filter": "Tags",
      "entity_filter": "Entidad",
      "subentity_filter": "Subentidad",
      "users_assigned": "Usuarios Asignados",
      "country_filter": "País",
      "users_assigned_filter": "Usuario",
      "country": {
        "ES": "España",
        "FR": "Francia",
        "PT": "Portugal",
        "IT": "Italia",
        "DE": "Alemania",
        "UK": "Reino Unido",
        "NL": "Países Bajos",
        "BE": "Bélgica",
        "CH": "Suiza",
        "AT": "Austria"
      },
      "department": {
        "IT": "Tecnología",
        "HR": "Recursos Humanos",
        "Finance": "Finanzas",
        "Operations": "Operaciones",
        "Sales": "Ventas",
        "Marketing": "Marketing"
      }
    },
    "messages": {
      "delete_group_confirm": "¿Estás seguro de que deseas eliminar este grupo de clientes?",
      "delete_group_success": "Grupo de clientes eliminado correctamente",
      "delete_group_error": "Error al eliminar el grupo de clientes",
      "group_saved_success": "Grupo guardado correctamente",
      "save_group_error_title": "Error",
      "save_group_error": "No se ha podido guardar el grupo de clientes",
      "delete_client_confirm": "¿Estás seguro de que deseas eliminar este cliente?",
      "delete_client_success": "Cliente eliminado correctamente",
      "delete_client_error": "Error al eliminar el cliente",
      "delete_client_error_title": "Error",
      "delete_client_not_implemented": "La eliminación de clientes no está disponible actualmente",
      "save_billing_error": "Error al guardar la cuenta de facturación",
      "load_billing_error": "Error al cargar la cuenta de facturación",
      "export_no_data": "No hay datos para exportar",
      "export_error": "Error al exportar los clientes",
      "export_groups_error": "Error al exportar los grupos de clientes"
    },
    "import": {
      "template_button": "PLANTILLA IMPORTACIÓN",
      "import_button": "IMPORTAR EXCEL",
      "info_button": "Guía de importación",
      "success": "Importación completada correctamente",
      "error_title": "Error en la importación",
      "no_records": "No hay registros para importar",
      "rows_failed": "No han podido importarse las filas {{rows}}",
      "success_count": "Se han creado {{count}} entidades",
      "server_error": "Error del servidor al importar datos"
    },
    "billing_import": {
      "template_button": "PLANTILLA IMPORTACIÓN",
      "import_button": "IMPORTAR EXCEL",
      "info_button": "Guía de importación de cuentas de facturación",
      "success": "Importación de cuentas de facturación completada correctamente",
      "error_title": "Error en la importación de cuentas de facturación",
      "template_filename": "plantilla_importacion_cuentas_facturacion.xlsx",
      "id_mismatch": "El ID del cliente actual es {{id}} y hay registros que no coinciden",
      "rows_failed": "No han podido importarse las filas {{rows}}",
      "success_count": "Se han importado un total de filas: {{count}}",
      "format_error": "Formato de archivo incorrecto",
      "server_error": "Error del servidor al importar cuentas de facturación"
    }
  },
  "tabs": {
    "groups": "Grupos de Clientes",
    "list": "Lista de Clientes",
    "general": "Información general",
    "protocol": "Protocolo",
    "slogans": "Consignas conductor",
    "documents": "Documentos",
    "extra-contact": "Contacto",
    "billing": "Facturación",
    "prices": "Precios",
    "certs": "Certificados",
    "additional-services": "Servicios Adicionales",
    "assignment": "Asignaciones de transportes",
    "history": "Gestión de transportes",
    "general-data": "Datos generales",
    "quality": "Calidad",
    "certifications": "Certificaciones",
    "blacklist": "Blacklist",
    "documentation": "Documentación",
    "timeline": "Timeline",
    "authorized": "Autorizados",
    "quality-report": "Informe de calidad",
    "mission-start": "Inicio de misión",
    "mission-mid": "Mitad de misión",
    "mission-end": "Fin de misión",
    "survey": "Encuesta",
    "budget-list": "Lista de presupuestos",
    "notifications": "Notificaciones",
    "manual-assignment": "Asignación manual",
    "incident-management": "Gestión incidencia",
    "metrics": "Métricas"
  },
  "transports": {
    "title": "Transportes",
    "modify_transport": "Modificar transporte",
    "survey": {
      "title": "Cuestionario a cliente final",
      "pickup_survey": "Encuesta de recogida",
      "delivery_survey": "Encuesta de entrega",
      "no_answers": "No se han registrado respuestas para esta fase.",
      "no_comment_provided": "Sin comentarios adicionales",
      "question": "Pregunta",
      "answer": "Respuesta"
    },
    "budget-over-transport": {
      "title": "Presupuestos sobre transporte",
      "id": "ID Transporte: "
    },
    "fast_edit": {
      "user_assigned": "Usuario asignado",
      "visible_budget": "Presupuesto visible",
      "transport_premium": "Transporte premium",
      "center_invoice": "Centro de facturación",
      "tags": "Etiquetas",
      "start_date": "Fecha de inicio",
      "start_hour_start_date": "Hora inicio (salida)",
      "end_hour_start_date": "Hora fin (salida)",
      "end_date": "Fecha de fin",
      "start_hour_end_date": "Hora inicio (llegada)",
      "end_hour_end_date": "Hora fin (llegada)",
      "enroll": "Matrícula",
      "send_secure": "Envío seguro",
      "customer_price": "Precio cliente",
      "number_ref": "Nº de referencia",
      "comments": "Comentarios",
      "comments_placeholder": "Escriba aquí sus comentarios..."
    },
    "list": {
      "movement_type_filter": "Tipo Movimiento"
    },
    "create": {
      "back": "Atrás",
      "not-assigned": "Sin asignar",
      "title": "Nuevo Transporte",
      "client-user": "Usuario cliente",
      "client-user-assigned": "Usuario cliente asignado",
      "manager": "Responsable",
      "panel-user-assigned": "Usuario interno asignado",
      "budget-visible": "Visible para presupuestar",
      "premium-transport": "Transporte premium",
      "transport-type": "Tipo de transporte",
      "simple-movement": "Movimiento simple",
      "pickup-to-final-customer": "Recogida a cliente final",
      "delivery-to-final-customer": "Entrega a cliente final",
      "pickup-and-delivery-to-final-customer": "Recogida y entrega a cliente final",
      "with-stopover": "Movimiento con parada (itv, taller, etc.)",
      "continue": "Continuar",
      "cancel": "Cancelar",
      "billing-center": "Centro de facturación",
      "pickup": "Recogida",
      "delivery": "Entrega",
      "pickup-address": "Dirección salida y contacto",
      "delivery-address": "Dirección de entrega y contacto",
      "schedule": "Horario",
      "departure": "Salida",
      "arrival": "Llegada",
      "available-from": "Disponible a partir de",
      "available-to": "Entregar antes de",
      "from": "Desde",
      "to": "Hasta",
      "min-time-range": "Las franjas horarias deben ser de dos horas como mínimo.",
      "date-required": "Debe seleccionar la fecha de recogida y entrega para poder guardar.",
      "add-delivery": "Añadir entrega",
      "add-stage": "Añadir etapa",
      "remove-stage-title": "¿Eliminar etapa?",
      "remove-stage-subtitle": "Se eliminará la tercera etapa del transporte y perderá los datos introducidos.",
      "vehicles": "Vehículo",
      "import-csv": "Importar CSV",
      "complementary-services-added": "Servicios adicionales añadidos",
      "plate-search": "Busque la matrícula para añadir vehículo",
      "add-vehicle": "Añadir otro vehículo",
      "cleaning-service": "Servicio de limpieza",
      "demostration-service": "Demostración vehículo",
      "revision-service": "Revisión técnica",
      "complementary-services": "Servicios adicionales",
      "no-complementary-services": "No hay servicios adicionales disponibles",
      "added": "Añadido",
      "required-documents": "Documentación",
      "add": "Añadir",
      "comments-reference": "Comentarios y referencia",
      "reference-number": "Nº referencia",
      "comments": "Comentarios",
      "publish-transport": "Publicar transporte",
      "cancel-transport": "Cancelar transporte",
      "save": "Guardar",
      "address-search-placeholder": "Escriba aquí...",
      "add-new-address": "AÑADIR NUEVA DIRECCION",
      "add-new-address-modal-title": "Nueva dirección",
      "pickup-address-hint": "Escribe manualmente o busca en tus favoritos",
      "add-address": "Añadir dirección",
      "name": "Nombre",
      "address-type": "Tipo de dirección",
      "country": "País",
      "province": "Provincia",
      "city": "Ciudad",
      "postal-code": "Código postal",
      "full-address": "Dirección completa",
      "address-complement": "Dirección complementaria",
      "address-data": "Datos dirección",
      "contacts": "Contactos",
      "phone": "Teléfono",
      "email": "Correo",
      "additional-contact-phones": "Teléfonos de contacto adicionales",
      "additional-contact-emails": "Correos de contacto adicionales",
      "add-another": "+ AÑADIR OTRO",
      "overwrite-associated-contact": "Sobrescribir contacto asociado",
      "declare-opening-hours": "Declarar horarios de apertura",
      "schedules": "Horarios",
      "opening-hours": "Horario de apertura",
      "time-slot": "Franja horaria",
      "add-time-slot": "AÑADIR FRANJA HORARIA",
      "schedule-label": "Horario:",
      "contact": "Contacto",
      "additional-contacts": "Contactos adicionales",
      "transport-not-found": "Transporte no encontrado",
      "stopover": "Etapa",
      "stop": "Parada",
      "license-plate": "Matrícula",
      "license-plate-required": "La Matrícula es obligatoria",
      "plate-not-found-title": "Matrícula no encontrada",
      "plate-not-found-manual-confirm": "La matrícula no se ha encontrado en el sistema. ¿Desea introducir los datos del vehículo de forma manual?",
      "brand": "Marca",
      "model": "Modelo",
      "vehicle-type": "Tipo de vehículo",
      "fuel-type": "Tipo de combustible",
      "documents-pickup-ab": "Documentos para recogida desde A → B",
      "documents-delivery-ab": "Documentos para entrega desde A → B",
      "documents-pickup-bc": "Documentos para recogida desde B → C",
      "documents-delivery-bc": "Documentos para entrega desde B → C",
      "appointment-pickup-hint": "El cliente final acordará la fecha y tramo de recogida mediante cita previa.",
      "appointment-delivery-hint": "El cliente final acordará la fecha y tramo de entrega mediante cita previa.",
      "appointment-dual-hint": "Las citas de recogida y entrega se concertarán directamente por el administrador."
    },
    "edit": {
      "title": "Editar Transporte"
    },
    "details": {
      "documents": {
        "required-title": "Documentación requerida de transporte",
        "driver-title": "Documentación subida por el conductor",
        "roadit-title": "Documentación subida por Roadit"
      }
    },
    "select-create": {
      "add-address": "Añadir dirección"
    },
    "schedule-modal": {
      "time-range-error": "La hora de inicio debe ser anterior a la hora de fin",
      "chronological-error": "Las fechas y horas deben estar en orden cronológico: recogida, escala (si existe) y entrega",
      "min-time-error": "La hora de recogida debe ser al menos 15 minutos desde ahora",
      "holidays": "Festivos",
      "address-required": "Seleccione las direcciones de recogida y entrega antes de programar las fechas",
      "holiday-warning-title": "Día festivo seleccionado",
      "holiday-warning-message": "El día {{date}} es festivo en {{location}}, asegúrese de garantizar la entrega o recogida del vehículo o de lo contrario se hará cargo de los costes correspondientes."
    },
    "assignments": {
      "id": "ID",
      "reference": "Referencia",
      "client_sub": "Entidad/Sub",
      "movement": "Movimiento",
      "date_time": "Fecha/Hora",
      "client_price": "Precio Cliente",
      "best_price": "Mejor Presupuesto",
      "appointment": "Cita",
      "tags": "Tags",
      "km_duration": "Km/Duración",
      "departure_arrival": "salida/llegada",
      "budget_number": "Nº Presupuesto",
      "responsible": "Responsable",
      "actions": "Acciones",
      "searchPlaceholder": "Buscar asignaciones...",
      "reference_filter": "Nº Referencia",
      "transport_number_filter": "Nº Transporte",
      "reservation_number_filter": "Nº Reserva",
      "creation_date_filter": "Fecha Creación",
      "departure_province_filter": "Provincia Salida",
      "arrival_province_filter": "Provincia Llegada",
      "email_filter": "Correo",
      "date_range_filter": "Inicio/Fin",
      "movement_type_filter": "Tipo Movimiento",
      "tags_filter": "Tags",
      "entity_filter": "Entidad",
      "subentity_filter": "Subentidad",
      "create_transport": "Crear Nuevo Transporte",
      "start_date": "Fecha inicio",
      "end_date": "Fecha fin",
      "lock_action": "Bloquear",
      "menu_action": "Más opciones",
      "driver": "Conductor",
      "fortnight_earnings": "Factura Quincenal",
      "score": "Puntuación",
      "status": "Estado",
      "budget": "Presupuesto",
      "margin": "Margen",
      "date_time_driver": "Fecha/Hora Conductor",
      "simulaneous_missions": "Misiones Simultáneas",
      "mission_id_button": "ID MISION",
      "reject_selected": "Rechazar seleccionados",
      "manage_appointment": "Gestionar cita",
      "budget-details": "Desglose del presupuesto",
      "budget-detailDrvier": "Contacto del conductor",
      "base-price": "Precio base",
      "fuel-price": "Combustible",
      "ferry-cost": "Ferry",
      "toll-expense": "Peajes",
      "optional-expenses": "Gastos opcionales",
      "outbound-cost": "Coste salida",
      "return-cost": "Coste retorno",
      "margin-eur": "Margen (EUR)",
      "total-price": "Precio total"
    },
    "history": {
      "id": "ID",
      "reference": "Referencia",
      "client_sub": "Entidad/Sub",
      "movement": "Movimiento",
      "date_time": "Fecha/Hora",
      "status": "Estado",
      "price": "Precio",
      "date_range": "Fecha/Hora",
      "tags": "Tags",
      "responsible": "Responsable",
      "duration": "Km/Duración",
      "admin": "Responsable",
      "actions": "Acciones",
      "searchPlaceholder": "Buscar historial...",
      "reference_filter": "Nº Referencia",
      "client_filter": "Entidad/Sub",
      "status_filter": "Estado",
      "date_range_filter": "Inicio/Fin",
      "tags_filter": "Tags",
      "driver": "Conductor",
      "duration_filter": "Duración",
      "admin_filter": "Admin",
      "actions_filter": "Acciones",
      "hours": "horas",
      "origin_province": "Provincia de salida",
      "destination_province": "Provincia de llegada",
      "driver_email": "Correo Conductor",
      "entity": "Entidad",
      "subentity": "Subentidad",
      "visible": "Visible",
      "appointment_required": "Gestión cita necesaria",
      "create": "CREAR NUEVO TRANSPORTE",
      "actions_column": {
        "lock": "Bloquear",
        "unlock": "Desbloquear",
        "calendar": "Gestionar cita",
        "hand": "Más opciones",
        "visibility": "Ver detalles",
        "folder": "Resumen del transporte",
        "calendar_pending": "Cita pendiente de concertar",
        "calendar_booked": "Cita concertada",
        "calendar_expired": "Gestionar cita (transporte caducado)"
      },
      "options": {
        "title": "Modificar datos de historial transporte",
        "summary": "Resumen del transporte",
        "modify": "Modificar transporte",
        "modify_plate": "Modificar matrícula",
        "modify_price": "Modificar precio facturación cliente",
        "add_return": "Añadir devolución",
        "manage_reservation": "Gestionar reserva",
        "unassigned_drivers": "Conductores desasignados",
        "regularizations": "Regularizaciones",
        "add_quality_incident": "Añadir incidencia de calidad",
        "duplicate": "Duplicar transporte",
        "cancel": "Cancelar transporte / Gestionar cancelación",
        "delete": "Eliminar transporte",
        "timeline": "Timeline transporte",
        "budget_history": "Historial de presupuestos"
      },
      "success": {
        "transport_blocked": "Transporte bloqueado correctamente",
        "transport_unblocked": "Transporte desbloqueado correctamente"
      },
      "errors": {
        "transport_id_not_found": "No se pudo identificar el transporte",
        "cannot_block_in_course": "No se puede bloquear un transporte que está en curso",
        "block_operation_failed": "Error al bloquear/desbloquear el transporte"
      },
      "pending_appointments_badge": "transportes requieren gestión cita",
      "filter_pending_tooltip": "Filtrar por transportes pendientes de concertar cita",
      "filter_pending_active_tooltip": "Quitar filtro de transportes pendientes de concertar cita"
    },
    "cancel": {
      "title": "Cancelar transporte",
      "cancelledBy": "Quien canceló",
      "cancelledByOptions": {
        "admin": "Administrador",
        "client": "Cliente"
      },
      "reason": "Motivo",
      "comment": "Comentario",
      "driverAction": "Acción sobre conductor",
      "clientAction": "Acción sobre cliente",
      "payDriver": "Pagar al conductor",
      "penalizeDriver": "Penalizar al conductor",
      "dontPayDriver": "No pagar al conductor",
      "selectOptions": "Seleccionar opciones",
      "manualEntry": "Introducir manualmente",
      "amount": "Cantidad",
      "less24h": "Menos de 24 horas (100%)",
      "between24_48h": "Entre 24 y 48 horas (50%)",
      "customPercentage": "% Personalizado",
      "percent": "Introduzca porcentaje",
      "mone": "Introduzca importe",
      "percentagePlaceholder": "Introduce un porcentaje (0-100)",
      "cancelButton": "CANCELAR TRANSPORTE",
      "clientOptions": {
        "less_24h": "Menos de 24 horas (100%)",
        "24_48h": "Entre 24 y 48 horas (50%)",
        "more_48h": "Más de 48 horas (0%)"
      },
      "errors": {
        "cancelledByRequired": "Debe seleccionar quién cancela el transporte.",
        "reasonRequired": "Debe seleccionar un motivo para la cancelación.",
        "messageRequired": "El comentario del motivo es obligatorio.",
        "negativeDriverPrice": "El importe para el conductor no puede ser negativo.",
        "negativeClientPercentage": "El porcentaje para el cliente no puede ser negativo.",
        "invalidDriverActionForRole": "La acción sobre el conductor no es válida para el actor que cancela.",
        "invalidClientActionForRole": "La acción sobre el cliente no es válida para el actor que cancela.",
        "invalidDriverPercent": "El porcentaje para el conductor no puede superar el 100%."
      },
      "success": "Transporte cancelado correctamente"
    },
    "unassign": {
      "errors": {
        "fetch_failed": "Error al obtener el desasignar"
      }
    },
    "manage_reservation": {
      "title": "Gestionar reserva",
      "prestacion": "Prestación",
      "transporte_hacia_recogida": "Transporte hacia recogida",
      "transporte_desde_entrega": "Transporte desde entrega",
      "peajes": "Peajes",
      "gastos_excepcionales": "Gastos excepcionales",
      "ferry": "Ferry",
      "combustible": "Combustible",
      "carga_vehiculo_electrico": "Carga vehículo eléctrico",
      "save": "GUARDAR",
      "cancel_reservation": "QUITAR RESERVA",
      "write_here": "Escriba aquí...",
      "loading": "Cargando datos de la reserva..."
    },
    "timeline": {
      "title": "Ver timeline del transporte",
      "modified_by": "modificado por",
      "view_ticket_details": "Ver detalle de ticket",
      "loading": "Cargando timeline...",
      "no_events": "No hay eventos en el timeline"
    },
    "edit_appointment": {
      "title": "Editar cita cliente final",
      "client_date": "Añadir fecha",
      "pickup_time": "Hora recogida a cliente final",
      "delivery_time": "Hora entrega cliente final",
      "from": "Desde:",
      "to": "Hasta:",
      "no_services_message": "Este transporte no tiene servicio de entrega o recogida",
      "transport_not_found": "Transporte no encontrado.",
      "client_not_found": "No se pudo encontrar el cliente del transporte",
      "load_error": "No se pudo cargar la información de la cita.",
      "client_availability_title": "Disponibilidad fecha clientes finales",
      "add_date": "Añadir fecha",
      "pickup_time_title": "Horario de recogida",
      "delivery_time_title": "Horario de entrega",
      "date_required": "Debe seleccionar una fecha para concertar la cita.",
      "save_success": "Cita guardada correctamente.",
      "save_error": "Error al guardar la cita.",
      "driver_conflict": "No es posible modificar la cita porque el transporte ya tiene un conductor asignado. Debe desasignar al conductor antes de actualizar la cita.",
      "pickup_appointment_title": "Cita de recogida con cliente final",
      "delivery_appointment_title": "Cita de entrega con cliente final",
      "pickup_date": "Fecha de recogida",
      "delivery_date": "Fecha de entrega",
      "pickup_date_required": "Debe seleccionar la fecha de recogida para concertar la cita.",
      "delivery_date_required": "Debe seleccionar la fecha de entrega para concertar la cita.",
      "field_required": "Este campo es obligatorio.",
      "date_out_of_range": "La fecha seleccionada está fuera del rango permitido.",
      "invalid_time_range": "La hora de fin debe ser posterior a la de inicio.",
      "delivery_before_pickup": "La fecha y hora de entrega no pueden ser anteriores a la recogida.",
      "resend_success": "Correo de cita reenviado correctamente.",
      "resend_error": "Error al reenviar el correo de cita.",
      "pending_customer_info": "Esta cita está pendiente de ser concertada por el cliente final a través del enlace enviado por correo.",
      "resend_button": "Reenviar correo",
      "resending": "Reenviando...",
      "last_sent_at": "Último envío:",
      "client_email": "Correo del cliente:",
      "no_email_warning": "No hay un correo electrónico de contacto configurado.",
      "manual_override_checkbox": "Concertar cita manualmente como administrador",
      "readonly_driver_warning": "Modo solo lectura: la cita no se puede modificar porque el transporte ya tiene conductor asignado.",
      "readonly_expired_warning": "Modo solo lectura: esta cita ha caducado y no admite modificaciones.",
      "no_active_appointments": "Este transporte cuenta con servicio de gestión de cita, pero fue registrado previamente a la activación del sistema digital. Por este motivo, no dispone de una cita activa vinculada en el servidor."
    },
    "retrieve": {
      "assigned-to": "Asignado a",
      "stopover": "Parada",
      "appointment-management": "Gestión de citas",
      "related-transport": "Transporte relacionado",
      "hide-general-info": "Ocultar información general",
      "show-general-info": "Mostrar información general",
      "download-mission-data": "Descargar resumen de misión",
      "pickup": "Recogida",
      "delivery": "Entrega",
      "stage": "Etapa",
      "contact-person": "Persona de contacto",
      "schedule": "Horario",
      "additional-contacts": "Contactos adicionales",
      "pickup-availability": "Disponibilidad fecha y hora recogida",
      "delivery-availability": "Disponibilidad fecha y hora entrega",
      "stage-availability": "Fecha y hora etapa",
      "availability-range": "De {{from}} a {{to}}",
      "vehicle": "Vehículo",
      "complementary-services": "Servicios complementarios",
      "no-complementary-services": "No hay servicios complementarios",
      "comments-reference": "Comentarios y referencia",
      "reference-number": "Nº de referencia",
      "comments": "Comentarios",
      "no-comments": "Sin comentarios",
      "driver": "Conductor",
      "no-driver-assigned": "El transporte no tiene aún un conductor asignado",
      "full-name": "Nombre completo",
      "email": "Email",
      "dni": "DNI",
      "phone": "Teléfono",
      "close": "Cerrar"
    },
    "quality-report": {
      "add-incident": "Añadir incidencia de calidad",
      "col_type": "Tipo",
      "col_reason": "Motivo",
      "col_entity": "ENTIDAD/SUB",
      "col_created_date": "Fecha creación",
      "col_driver": "Conductor",
      "col_status": "Estado",
      "col_responsible": "Responsable",
      "col_actions": "Acciones",
      "responsible_admin": "Administrador",
      "responsible_client": "Cliente"
    },
    "incident-form": {
      "errors": {
        "no-drivers-assigned": "No hay conductores asignados al transporte"
      },
      "title": "Registrar una incidencia de calidad",
      "description": "Indícanos qué ha ocurrido en este transporte. Recogeremos la información necesaria para revisarlo y darte una solución.",
      "emergency": "Para una emergencia en curso, ponte en contacto con nosotros a través del (+34) ...",
      "start": "COMENZAR",
      "step2": {
        "title": "Información",
        "freshdesk-client": "Enlace Freshdesk para cliente",
        "freshdesk-driver": "Enlace Freshdesk para conductor",
        "select-driver": "Seleccionar a conductor",
        "back": "ATRÁS",
        "cancel": "CANCELAR",
        "next": "SIGUIENTE"
      },
      "step3": {
        "title": "Tipo de incidencia",
        "main-type": "Motivos",
        "subtype": "Submotivo",
        "loading-subtypes": "Cargando subtipos...",
        "quantity": "Cantidad",
        "quantity-hours-placeholder": "Escriba las horas...",
        "quantity-km-placeholder": "Escriba los kilómetros...",
        "quantity-liters-placeholder": "Escriba los litros...",
        "quantity-amount-placeholder": "Escriba la cantidad...",
        "back": "ATRÁS",
        "cancel": "CANCELAR",
        "next": "SIGUIENTE"
      },
      "step4": {
        "title": "Detalles*",
        "description": "Describe lo ocurrido para que podamos revisarlo (mínimo 10 caracteres)",
        "placeholder": "Escriba aquí...",
        "back": "ATRÁS",
        "cancel": "CANCELAR",
        "next": "SIGUIENTE"
      },
      "step5": {
        "title": "Adjuntar archivos",
        "description": "Puedes añadir imágenes, videos o documentos que ayuden a revisar esta incidencia.",
        "add-file": "AÑADIR",
        "no-files": "No hay archivos adjuntos",
        "download": "Descargar",
        "delete": "Eliminar",
        "back": "ATRÁS",
        "cancel": "CANCELAR",
        "next": "ENVIAR"
      },
      "success": {
        "title": "Incidencia registrada",
        "message": "Muchas gracias por ayudarnos a mejorar. Revisaremos en detalle la incidencia reportada y te mantendremos informado",
        "close": "CERRAR"
      },
      "driver": {
        "asigned": "Asignado al trayecto"
      }
    },
    "budgets": {
      "driver_earnings": "Ganancias quincena",
      "accept": "Aceptar",
      "reject": "Rechazar",
      "rejected": "RECHAZADO",
      "accepted": "ACEPTADO",
      "confirm_accept_title": "¿Seguro que quiere aceptar el presupuesto?",
      "confirm_accept_message": "El conductor tiene otras misiones coincidentes",
      "confirm_reject_title": "¿Seguro que quiere rechazar el presupuesto?",
      "confirm_reject_selected_title": "¿Seguro que quiere rechazar los presupuestos?",
      "no_selected_title": "No hay presupuestos seleccionados",
      "no_selected_message": "Selecciona al menos un presupuesto para rechazar",
      "no_pending_title": "No hay presupuestos pendientes",
      "no_pending_message": "Los presupuestos seleccionados ya han sido procesados",
      "accept_success": "Presupuesto aceptado correctamente",
      "accept_error": "Error al aceptar el presupuesto",
      "reject_success": "Presupuesto rechazado correctamente",
      "reject_error": "Error al rechazar el presupuesto",
      "reject_selected_success": "Presupuestos rechazados correctamente",
      "reject_selected_error": "Error al rechazar los presupuestos",
      "show_top_10": "Ver TOP 10 de presupuestos",
      "breakdown": {
        "base_price": "Precio base",
        "fuel_price": "Combustible",
        "transport_cost_outbound": "Transporte ida",
        "transport_cost_return": "Transporte vuelta",
        "optional_expenses": "Gastos opcionales",
        "accommodation_cost": "Alojamiento",
        "toll_expense": "Peajes",
        "per_diem_cost": "Dietas"
      },
      "message_label": "Mensaje",
      "optional": "opcional",
      "message_placeholder_accept": "Escribe un mensaje para el conductor (opcional)...",
      "message_placeholder_reject": "Escribe el motivo del rechazo (opcional)...",
      "selected_count": "Presupuestos seleccionados",
      "confirm_title": "Confirmación",
      "departure_arrival": "Salida / Llegada"
    },
    "notifications": {
      "city": "Ciudad",
      "driver": "Conductor",
      "email": "Correo",
      "score": "Puntuación",
      "budget": "Presupuesto",
      "compatibility": "Compatibilidad",
      "simultaneous_missions": "Misiones simultáneas",
      "budget-in-transport": "Presupuesto sobre el transporte",
      "compatible-drivers": "Conductores compatibles",
      "has-other-transports": "Tiene otros transportes",
      "driver-score": "Puntuación del conductor",
      "rating-min": "Puntuación mínima",
      "rating-max": "Puntuación máxima",
      "both": "Ambos",
      "send-notification": "Enviar notificación",
      "send_modal": {
        "title": "Enviar notificaciones",
        "title_label": "Título",
        "title_placeholder": "Escriba el título...",
        "message_label": "Mensaje",
        "message_placeholder": "Escriba aquí...",
        "send_by_label": "Enviar por",
        "push": "Notificación PUSH",
        "email": "Email",
        "send_button": "ENVIAR NOTIFICACIONES",
        "sending": "ENVIANDO...",
        "success": "Notificaciones enviadas correctamente.",
        "error": "Error al enviar las notificaciones.",
        "no_selection": "No hay conductores seleccionados",
        "no_selection_subtitle": "Selecciona al menos un conductor de la tabla para enviar notificaciones.",
        "no_emails": "Los conductores seleccionados no tienen email"
      }
    },
    "messages": {
      "duplicate-vehicle-error": "Ya existe un vehículo con esa matrícula en el transporte.",
      "delete-document-confirm": "¿Estás seguro de que deseas eliminar este documento?",
      "publish-success": "Transporte publicado con éxito.",
      "update-success": "Transporte modificado correctamente",
      "execeded-kilometres": "El cliente no tiene definidos precios para los kilómetros del trayecto",
      "validation-error-prefix": "El transporte no es válido:",
      "validation-admin-required": "El transporte debe tener un administrador asignado.",
      "validation-billing-required": "El transporte debe tener una cuenta de facturación asignada.",
      "validation-vehicle-required": "El transporte debe tener al menos un vehículo asignado.",
      "validation-origin-address-required": "El transporte debe tener una dirección de recogida en cada etapa.",
      "validation-destination-address-required": "El transporte debe tener una dirección de entrega en cada etapa.",
      "validation-leg-required": "El transporte debe tener al menos una etapa.",
      "validation-departure-date-required": "El transporte debe tener una fecha de recogida.",
      "validation-arrival-date-required": "El transporte debe tener una fecha de entrega.",
      "validation-reference-required": "El transporte debe tener un número de referencia.",
      "publish-error": "Error en el servidor al guardar el transporte",
      "manual-price-minor": "El precio manual es menor que el precio calculado",
      "validation-total-time-short": "El intervalo de tiempo entre la recogida y la entrega es inferior al tiempo estimado del trayecto."
    },
    "manual-assign": {
      "searchPlaceholder": "Buscar conductor...",
      "full-name": "Nombre completo",
      "dni": "DNI",
      "driver-score": "Puntuación del conductor",
      "fortnight-earnings": "Ganancias quincena",
      "no-driver-selected": "No hay conductor seleccionado",
      "margin": "Margen",
      "createBudget": "Crear presupuesto",
      "outbound": "Ida",
      "return": "Vuelta",
      "service": "Prestación",
      "transportToPickup": "Transporte hacia recogida",
      "transportFromDelivery": "Transporte desde entrega",
      "additionalCosts": "Costes adicionales",
      "tolls": "Peajes",
      "exceptionalExpenses": "Gastos excepcionales",
      "ferry": "Ferry",
      "electricVehicleCharge": "Carga vehículo eléctrico",
      "fuel": "Combustible",
      "dateAndTime": "Fecha y hora",
      "addDate": "Fecha de recogida",
      "deliveryDate": "Fecha de entrega",
      "pickup": "Recogida",
      "delivery": "Entrega",
      "assignMission": "ASIGNAR MISIÓN",
      "appointment_booked_info": "Fecha y horario fijados por cita acordada con el cliente final.",
      "appointment_pending_info": "Este trayecto cuenta con gestión de cita pendiente de concertar.",
      "errors": {
        "prestacion": "La prestación es obligatoria",
        "transporteRecogida": "El transporte hacia recogida es obligatorio",
        "transporteEntrega": "El transporte desde entrega es obligatorio",
        "fecha": "La fecha es obligatoria",
        "horaRecogida": "La hora de recogida es obligatoria",
        "horaEntrega": "La hora de entrega es obligatoria",
        "outOfDate": "La fecha no está en el rango admitible",
        "appointmentPending": "No es posible asignar conductor mientras la cita esté pendiente de concertar."
      }
    },
    "mission": {
      "control_panel": "Panel de control",
      "movement_protocols": "Protocolos de movimiento",
      "inspection_photos": "Fotos de peritación",
      "exterior_photos": "Fotos exterior",
      "interior_photos": "Fotos interior",
      "exit_anomalies": "Anomalías salida",
      "delivery_anomalies": "Anomalías entrega",
      "budgeted": "Presupuestada:",
      "real": "Real:",
      "photo_signature": "Foto y Firma",
      "delivery_signatures": "Firmas entrega",
      "driver_signature": "Firma conductor",
      "professional_driver": "Conductor profesional",
      "exit_client": "Cliente salida",
      "delivery_contact": "Contacto entrega",
      "fuel_amount": "Cantidad de combustible",
      "amount_km": "Cantidad en Km",
      "keys_label": "Llaves (total llaves entregadas)",
      "charging_cables": "Cables de carga",
      "registration_certificate": "Permiso de circulación",
      "technical_sheet": "Ficha técnica",
      "spare_wheel": "Rueda repuesto / Kit pinchazos",
      "reflective_vest": "Chaleco reflectante (opcional)",
      "v16_beacom": "Baliza V16 (opcional)",
      "km": "Km",
      "km_diff_pickup_address": "Km de diferencia con la dirección de recogida",
      "km_diff_delivery_address": "Km de diferencia con la dirección de entrega",
      "no_protocols": "Sin protocolos relacionados",
      "no_anomalies": "Sin anomalías de salida",
      "no_services": "Sin servicios complementarios",
      "no_exterior_photos": "Sin fotos de exterior",
      "no_interior_photos": "Sin fotos de interior",
      "pickup_address": "Dirección de salida",
      "delivery_address": "Dirección de entrega",
      "geolocation_pickup_preparation": "Geolocalización preparación de recogida",
      "geolocation_delivery_preparation": "Geolocalización preparación de entrega",
      "geolocation_pickup_send": "Geolocalización envío de recogida",
      "geolocation_delivery_send": "Geolocalización envío de entrega",
      "pickup_datetime": "Fecha y hora recogida",
      "delivery_datetime": "Fecha y hora entrega"
    }
  },
  "notifications": {
    "title": "Notificaciones",
    "create": "Crear notificación",
    "searchPlaceholder": "Buscar...",
    "list": {
      "searchPlaceholder": "Buscar"
    },
    "columns": {
      "title": "Título",
      "message": "Mensaje",
      "send_to": "Enviar a",
      "target": "Destinatarios",
      "status": "Estado",
      "scheduled": "Programada",
      "specific_users": "Usuarios específicos",
      "actions": "Acciones"
    },
    "actions": {
      "resend": "reenviar",
      "view": "Ver",
      "edit": "Editar",
      "delete": "Eliminar"
    },
    "frequency": {
      "DAILY": "Diaria",
      "WEEKLY": "Semanal",
      "MONTHLY": "Mensual",
      "YEARLY": "Anual"
    },
    "status": {
      "sent": "Enviada",
      "scheduled": "Programada",
      "cancelled": "Cancelada"
    },
    "send_by": {
      "push": "Push",
      "email": "Email",
      "both": "Ambos (Push y Email)"
    },
    "type": {
      "custom": "Personalizada",
      "custom_transport": "Transporte",
      "system": "Sistema"
    },
    "target": {
      "all": "Todos los usuarios",
      "all_clients": "Todos los clientes",
      "all_drivers": "Todos los conductores",
      "specific_drivers": "Conductores específicos",
      "specific_clients": "Clientes específicos",
      "custom": "Usuarios personalizados"
    },
    "advice_custom_transport_no_edit": "Las notificaciones vinculadas a transportes no se pueden editar ni reenviar desde este módulo. Deben gestionarse desde Asignación de Transportes.",
    "filters": {
      "title": "Título",
      "send_to": "Enviar a",
      "scheduled": "Programada",
      "date_range": "Intervalo de fechas"
    },
    "editor": {
      "create_title": "Crear notificación",
      "edit_title": "Editar notificación",
      "view_title": "Detalle de notificación",
      "title_label": "Título",
      "title_placeholder": "Escriba aquí...",
      "message_label": "Mensaje",
      "message_placeholder": "Escriba el mensaje de la notificación...",
      "target_label": "Selecciona a quién va dirigida la notificación",
      "channel_label": "Canal de envío",
      "specific_drivers_title": "Conductores específicos",
      "custom_recipients_title": "Destinatarios personalizados ({{count}})",
      "custom_transport_info_title": "Notificación vinculada a un transporte",
      "custom_transport_info_msg": "Esta notificación fue enviada a destinatarios personalizados para el transporte {{id}}. No es editable desde este módulo; para nuevas comunicaciones, debe gestionarse desde Asignación de Transportes.",
      "custom_transport_view_btn": "Ver transporte {{id}}",
      "filter_name": "Nombre",
      "filter_email": "Correo",
      "filter_city": "Provincia",
      "filter_phone": "Teléfono",
      "filter_tag": "Tags",
      "filter_status": "Estado",
      "drivers_search_placeholder": "Buscar...",
      "selected_drivers_count": "{count} seleccionados",
      "select_all": "Seleccionar todos",
      "deselect_all": "Deseleccionar todos",
      "schedule_btn": "Programar envío",
      "edit_schedule_btn": "Modificar programación",
      "scheduled_badge": "Programado para:",
      "send_now": "Enviar",
      "save_changes": "Guardar cambios",
      "cancel": "Cancelar",
      "back": "Atrás",
      "validation_title": "El título es obligatorio.",
      "validation_message": "El mensaje es obligatorio.",
      "validation_drivers": "Debes seleccionar al menos un conductor.",
      "success_created": "Notificación creada y enviada con éxito.",
      "success_scheduled": "Notificación programada con éxito.",
      "success_updated": "Notificación programada actualizada con éxito.",
      "error_saving": "Ha ocurrido un error al procesar la notificación."
    },
    "schedule_modal": {
      "title": "Programar envío",
      "mode_schedule": "Programar envío",
      "mode_now": "Enviar ahora",
      "date": "Fecha",
      "time": "Hora",
      "timezone": "Zona horaria",
      "repeat": "Repetir envío",
      "frequency": "Repetición",
      "every": "Cada",
      "days": "día(s)",
      "weeks": "semana(s)",
      "months": "mes(es)",
      "years": "año(s)",
      "repeat_on": "Se repite",
      "weekdays": {
        "MONDAY": "lun",
        "TUESDAY": "mar",
        "WEDNESDAY": "mié",
        "THURSDAY": "jue",
        "FRIDAY": "vie",
        "SATURDAY": "sáb",
        "SUNDAY": "dom"
      },
      "month_options": {
        "by_day": "El día del mes",
        "by_weekday": "El día de la semana"
      },
      "month_day": "El día",
      "on_the": "El",
      "nth_weekday": {
        "1": "Primer",
        "2": "Segundo",
        "3": "Tercer",
        "4": "Cuarto"
      },
      "weekday_names": {
        "MONDAY": "Lunes",
        "TUESDAY": "Martes",
        "WEDNESDAY": "Miércoles",
        "THURSDAY": "Jueves",
        "FRIDAY": "Viernes",
        "SATURDAY": "Sábado",
        "SUNDAY": "Domingo"
      },
      "ends": "Finaliza",
      "never": "Nunca",
      "on_date": "El día",
      "after": "Después de",
      "occurrences": "envíos",
      "save": "Guardar",
      "cancel": "Cancelar"
    },
    "header": {
      "title": "Notificaciones",
      "empty": "No tienes notificaciones pendientes",
      "mark_as_read": "Marcar como leída",
      "date_time": "Fecha y hora"
    }
  },
  "regularizations": {
    "validation": {
      "required": "Debes seleccionar un elemento",
      "field-required": "El campo no puede quedar vacío",
      "amount-positive": "Debe tener un valor numérico positivo válido",
      "message-min-length": "El comentario debe tener al menos 10 caracteres"
    },
    "title": "Regularizaciones/Desasignaciones",
    "back": "Atrás",
    "driver-name": "Nombre del conductor",
    "transport": "Transporte",
    "no-transport": "Sin transporte",
    "regularization-type": "Tipo de regularización",
    "type": "Tipo",
    "good-work": "Buen trabajo",
    "bad-work": "Mal trabajo",
    "other": "Otro",
    "comment": "Comentario",
    "comment-placeholder": "Añade un comentario",
    "amount": "Importe",
    "save-changes": "Guardar cambios",
    "select-regularization-type": "Selecciona tipo de regularización",
    "select-type": "Selecciona tipo de regularización",
    "list": {
      "searchPlaceholder": "Buscar regularizaciones...",
      "driver_name": "Conductor",
      "unassigned_by": "Quien desasigna",
      "option": "Opción",
      "percentage": "Porcentaje",
      "amount": "Importe",
      "type": "Tipo",
      "status": "Estado",
      "actions": "Acciones",
      "create": "Añadir regularización",
      "transport-id": "ID Transporte: ",
      "transport": "Transporte",
      "types": {
        "regulation": "Regularización",
        "unassign": "Desasignación"
      },
      "statuses": {
        "pending": "Pendiente",
        "billed": "Facturada"
      }
    },
    "edit": {
      "title": "Editar regularización"
    },
    "create": {
      "title": "Añadir regularización"
    },
    "unassign": {
      "title": "Gestionar desasignación",
      "servicePrice": "Precio de la prestación",
      "payDriver": "Pagar al conductor",
      "penalizeDriver": "Penalizar al conductor",
      "onlyRemoveReservation": "Sólo quitar la reserva",
      "selectOptions": "Seleccionar opciones",
      "manualEntry": "Introducir manualmente",
      "amountPlaceholder": "Importe",
      "removeDriver": "QUITAR CONDUCTOR",
      "success": {
        "removed": "Conductor desasignado correctamente",
        "updated": "Desasignación modificada correctamente"
      },
      "errors": {
        "unassign_failed": "Error al desasignar conductor",
        "amount_required": "Cantidad requerida"
      }
    }
  },
  "additional-costs": {
    "searchPlaceholder": "Buscar...",
    "pending_admin": "Pendientes de administrar",
    "pending_ticket": "Pendientes de ticket",
    "columns": {
      "name": "Nombre",
      "dni_cif": "DNI / CIF",
      "email": "Correo",
      "phone": "Teléfono",
      "rating": "Punt.",
      "tags": "Tags",
      "transport": "Transporte",
      "type": "Tipo",
      "amount_requested": "Imp. Sol",
      "amount_quoted": "Imp. Pres",
      "status": "Estado",
      "actions": "Acciones"
    },
    "filters": {
      "tags": "Tags",
      "email": "Correo",
      "name": "Nombre",
      "phone": "Teléfono",
      "rating": "Puntuación",
      "request_date": "Intervalo Solicitud",
      "modified_date": "Intervalo Actualización",
      "status": "Estado",
      "transport_id": "ID Transporte"
    },
    "status": {
      "NEW": "Nueva",
      "PENDING_TICKET": "Pendiente ticket",
      "EXPIRED": "Fuera de plazo",
      "PENDING_VALIDATION": "Pendiente validación",
      "VALIDATED": "Validada",
      "REQUEST_REJECTED": "Solicitud rechazada",
      "TICKET_REJECTED": "Ticket rechazado"
    },
    "request_type": {
      "TAXI": "Taxi",
      "BLABLACAR": "Blablacar",
      "TRAIN": "Tren",
      "PLANE": "Avión",
      "TOLL": "Peaje",
      "FUEL": "Combustible",
      "MEALS": "Dietas (10% IVA)",
      "LODGING": "Hospedaje",
      "WAITING_TIME": "Tiempo de espera",
      "ELECTRIC_VEHICLE_CHARGING_TIME": "Carga de vehículo eléctrico",
      "ADBLUE": "AdBlue",
      "OIL": "Aceite",
      "FERRY": "Ferry",
      "OTHER": "Otro"
    },
    "messages": {
      "export_error": "Error al exportar gastos adicionales"
    },
    "manage": {
      "title": "Gestionar solicitud",
      "action_label": "Gestionar",
      "type": "Tipo",
      "price_without_tax": "Precio (Impuestos no incluidos)",
      "price_with_vat": "Precio ({{vat_percentage}}% IVA incluido)",
      "driver_comment": "Comentario conductor",
      "ticket": "Ticket",
      "vehicle_frame_photo": "Foto cuadro vehículo",
      "rejection_section_title": "Necesario en caso de rechazo",
      "rejection_reason": "Motivo rechazo",
      "select_reason": "Selecciona un motivo",
      "message": "Mensaje",
      "message_placeholder": "Mensaje por defecto asociado al motivo",
      "block_new_request": "No permitir nueva solicitud de este tipo al conductor sobre el transporte",
      "exclude_from_invoice": "No repercutir al cliente en la factura",
      "approve_request": "APROBAR SOLICITUD",
      "approve_expense": "APROBAR GASTO",
      "reject": "RECHAZAR",
      "rejection_reason_required": "Debes seleccionar un motivo de rechazo",
      "load_error": "Error al cargar los datos del gasto adicional",
      "reject_success": "Solicitud rechazada correctamente",
      "reject_error": "Error al rechazar la solicitud",
      "approve_success": "Solicitud aprobada correctamente",
      "approve_error": "Error al aprobar la solicitud",
      "approve_ticket_success": "Gasto aprobado correctamente",
      "approve_ticket_error": "Error al aprobar el gasto"
    }
  },
  "driver-invoices": {
    "title": "Facturas de conductores",
    "searchPlaceholder": "Buscar facturas...",
    "pending_payment": "Pendientes de pago",
    "mark_as": "MARCAR COMO",
    "export_csv": "EXPORTAR CSV",
    "export_csv_bank": "EXPORTAR CSV BANCO",
    "download_selected_pdf": "DESCARGAR SELECCIONADOS EN PDF",
    "columns": {
      "emission_date": "EMISIÓN",
      "payment_date": "PAGO",
      "name": "NOMBRE",
      "dni_cif": "DNI / CIF",
      "email_phone": "CORREO / TEL.",
      "embargo": "EMBARGO",
      "status": "ESTADO",
      "total_amount": "TOTAL FACTURA (SIN IVA)",
      "regs": "REGS.",
      "ttes": "TTES.",
      "actions": "ACCIÓN"
    },
    "filters": {
      "driver_email": "Correo conductor",
      "name": "Nombre",
      "dni_cif": "DNI / NIE / CIF",
      "phone": "Teléfono",
      "embargo": "Embargo",
      "status": "Estado factura",
      "total": "Total",
      "emission_date_range": "Intervalo fecha de emisión",
      "payment_date_range": "Intervalo fecha de pago",
      "includes_regularizations": "Incluye regularizaciones",
      "includes_transports": "Incluye transportes"
    },
    "embargo_options": {
      "yes": "Sí",
      "no": "No"
    },
    "status": {
      "PENDING_DRIVER": "Pte. Conductor",
      "PENDING_PAYMENT": "Pte. de Pago",
      "PAID": "Pagado"
    },
    "actions": {
      "view": "Ver",
      "export_pdf": "Exportar PDF",
      "export_csv": "Exportar CSV",
      "export_bank": "Exportar Banco"
    },
    "mark_modal": {
      "title": "Marcar facturas como",
      "pending_payment": "Pendiente de pago",
      "paid": "Pagada",
      "save": "GUARDAR"
    },
    "messages": {
      "no_selection": "No hay facturas seleccionadas",
      "no_selection_subtitle": "Selecciona al menos una factura para cambiar su estado",
      "status_changed_success": "Estado actualizado correctamente",
      "status_changed_count": "Se han actualizado {{count}} factura(s)",
      "status_changed_error": "Error al cambiar el estado de las facturas",
      "generating_pdf": "Generando archivo PDF, por favor espere...",
      "export_success": "Archivo exportado correctamente",
      "export_error": "Error al exportar facturas a PDF"
    }
  },
  "create-driver-invoices": {
    "title": "Emisión de facturas a conductores",
    "coming_soon": "Contenido próximamente disponible",
    "drivers_list": "Listado de conductores",
    "invoices_to_emit": "Facturas a emitir",
    "emit_draft_selection": "EMITIR BORRADOR DE LA SELECCIÓN",
    "emit_individual_draft": "EMITIR BORRADOR INDIVIDUAL",
    "request_invoice_data": "Solicitar datos de facturación",
    "loading": "Cargando...",
    "no_invoice_data": "No hay datos de facturación. Selecciona conductores en la tabla superior y haz clic en 'Solicitar datos de facturación'.",
    "total_to_emit": "TOTAL A EMITIR",
    "select_all": "Marcar todo",
    "transports": "Transportes",
    "other_adjustments": "Otras regularizaciones",
    "adjustments": "Regularizaciones",
    "draft": "Borrador",
    "draft_placeholder": "Selecciona transportes o regularizaciones para añadir al borrador",
    "searchPlaceholder": "Buscar conductores...",
    "columns": {
      "photo": "Foto",
      "name": "Nombre",
      "dni_nie": "DNI/NIE",
      "phone": "Teléfono",
      "email": "Correo",
      "pending_transports": "Transportes pendientes facturar",
      "pending_adjustments": "Regularizaciones pendientes"
    },
    "tables": {
      "id": "ID",
      "status": "Estado",
      "additional_costs": "Gastos adicionales (sin IVA)",
      "adjustments": "Regs. (Sin IVA)",
      "total": "Total (Sin IVA)",
      "type": "Tipo",
      "reason": "Motivo",
      "sub_reason": "Submotivo",
      "quantity": "Cantidad",
      "amount": "Importe (sin IVA)",
      "no_transports": "No hay transportes disponibles",
      "no_adjustments": "No hay regularizaciones disponibles"
    },
    "tooltip": {
      "budget": "Presupuesto",
      "total_price": "Precio total",
      "additional_costs": "Gastos adicionales",
      "adjustments": "Regularizaciones"
    },
    "summary": {
      "base_amount": "BASE IMPONIBLE",
      "vat": "IVA",
      "total": "TOTAL A EMITIR"
    },
    "filters": {
      "name": "Nombre",
      "dni_nie": "DNI/NIE",
      "email": "Correo",
      "phone": "Teléfono",
      "transport_end_date": "Intervalo fecha finalización transporte"
    },
    "confirm_emit_individual": "¿Estás seguro de que quieres emitir el borrador de este conductor?",
    "confirm_emit_selection": "¿Estás seguro de que quieres emitir los borradores de todos los conductores seleccionados?",
    "emit_success": "Facturas creadas correctamente",
    "emit_error": "Error al crear las facturas",
    "no_items_selected": "No hay transportes seleccionados o no son facturables"
  },
  "client-invoices": {
    "title": "Gestión de facturas a clientes",
    "searchPlaceholder": "Buscar facturas...",
    "pending_payment": "Pendientes de pago",
    "mark_as": "MARCAR COMO",
    "manual_emission": "EMISIÓN MANUAL DE FACTURAS",
    "export_csv": "EXPORTAR CSV",
    "export_csv_bank": "EXPORTAR CSV BANCO",
    "download_selected_pdf": "DESCARGAR SELECCIONADOS EN PDF",
    "columns": {
      "invoice_number": "Nº FACTURA",
      "group": "GRUPO",
      "entity_sub": "ENTIDAD/SUB",
      "cif": "CIF",
      "emission_date": "EMISIÓN",
      "expiration_date": "VENCIMIENTO",
      "total_transports": "TOTAL TRANSP.",
      "amount_no_vat": "IMPORTE (SIN IVA)",
      "status": "ESTADO",
      "actions": "ACCIÓN"
    },
    "filters": {
      "invoice_number": "Nº Factura",
      "group": "Grupo",
      "entity": "Entidad",
      "subentity": "Subentidad",
      "cif": "CIF",
      "status": "Estado",
      "emission_date_range": "Emisión facturas",
      "expiration_date_range": "Vencimiento facturas",
      "pending_overdue": "Facturas pendientes con fecha de vencimiento pasada"
    },
    "status": {
      "PENDING_DRIVER": "Pte. Conductor",
      "PENDING_PAYMENT": "Pte. de Pago",
      "PAID": "Pagada"
    },
    "actions": {
      "view": "Ver factura",
      "download_pdf": "Descargar PDF",
      "download_csv": "Descargar CSV",
      "download_bank": "Descargar formato banco"
    },
    "mark_modal": {
      "title": "Marcar facturas como",
      "pending_payment": "Pendiente de pago",
      "paid": "Pagada",
      "save": "GUARDAR"
    },
    "messages": {
      "no_selection": "No hay facturas seleccionadas",
      "no_selection_subtitle": "Selecciona al menos una factura para cambiar su estado",
      "status_changed_success": "Estado actualizado correctamente",
      "status_changed_count": "Se han actualizado {{count}} factura(s)",
      "status_changed_error": "Error al cambiar el estado de las facturas",
      "export_error": "Error al exportar facturas a PDF",
      "generating_pdf": "Generando archivo PDF, por favor espere...",
      "export_success": "Archivo exportado correctamente"
    },
    "emit_modal": {
      "title": "Seleccionar clientes",
      "search_placeholder": "Buscar cliente...",
      "selected_clients": "Clientes seleccionados",
      "no_clients": "No hay clientes pendientes de facturar",
      "no_selected": "No hay clientes seleccionados",
      "emit_button": "EMISIÓN MANUAL DE FACTURAS",
      "loading": "Cargando clientes...",
      "error_loading": "Error al cargar clientes",
      "error_loading_subtitle": "No se pudieron obtener los clientes pendientes de facturar",
      "error_creating": "Error al crear facturas",
      "error_creating_subtitle": "No se pudieron crear las facturas para los clientes seleccionados",
      "success": "Facturas creadas correctamente",
      "success_count": "Se han creado {{count}} factura(s)",
      "no_pending": "Sin elementos pendientes",
      "no_pending_subtitle": "Este cliente no tiene transportes ni costes adicionales pendientes de facturar"
    }
  },
  "invoice-detail": {
    "title": "Detalle Factura",
    "invoice_number_label": "Nº Factura",
    "detail_title": "Detalle factura",
    "data_title": "Datos de Factura",
    "transports_title": "Transportes",
    "no_transports": "No hay transportes asociados a esta factura",
    "status": {
      "PENDING_DRIVER": "Pte. Conductor",
      "PENDING_PAYMENT": "Pte. de Pago",
      "PAID": "Pagada"
    },
    "fields": {
      "invoice_number": "Nº Factura",
      "status": "Estado",
      "name": "Nombre",
      "dni_nie_cif": "DNI / NIE / CIF",
      "irpf": "IRPF",
      "phone": "Teléfono",
      "address": "Dirección",
      "address_complement": "Complemento dirección",
      "country": "País",
      "province": "Provincia",
      "city": "Ciudad",
      "postal_code": "Código Postal",
      "iban": "IBAN",
      "bic_swift": "BIC / SWIFT",
      "group": "Grupo",
      "entity": "Entidad",
      "subentity": "Subentidad",
      "billing_center": "Centro de facturación",
      "cif": "CIF",
      "emission_date": "Emisión de la factura",
      "expiration_date": "Vencimiento de la factura",
      "payment_date": "Pago de la factura",
      "transports_count": "Cantidad de transportes",
      "finished_transports_count": "Cantidad de transportes finalizados",
      "cancelled_transports_count": "Cantidad de transportes cancelados",
      "annulled_transports_count": "Cantidad de transportes anulados",
      "base_amount": "Base imponible",
      "vat_amount": "IVA",
      "irpf_amount": "IRPF",
      "total_amount": "Total a emitir"
    },
    "transport_columns": {
      "transport_number": "Nº TRANSPORTE",
      "license_plate": "MATRÍCULA",
      "status": "ESTADO",
      "pickup": "RECOGIDA",
      "stopover": "PARADA",
      "delivery": "ENTREGA",
      "price": "TOTAL (SIN IVA)",
      "additional_costs": "G. ADICIONALES (SIN IVA)",
      "regs_amount": "REGS. (SIN IVA)",
      "regs": "REGS.",
      "penalty": "PENALIZACIÓN"
    },
    "transport_status": {
      "FINISHED": "Finalizado",
      "CANCELLED": "Cancelado",
      "EXPIRED": "Expirado",
      "IN_PROGRESS": "En progreso",
      "PENDING": "Pendiente",
      "UNASSIGNED": "Anulado"
    },
    "actions": {
      "save": "GUARDAR"
    },
    "messages": {
      "load_error": "Error al cargar el detalle de la factura",
      "status_changed_success": "Estado actualizado correctamente",
      "status_changed_error": "Error al cambiar el estado",
      "invoice_number_error": "Error al actualizar el nº de factura",
      "save_success": "Cambios guardados correctamente",
      "invoice_number_required": "El número de factura es obligatorio",
      "generating_pdf": "Generando archivo PDF, por favor espere...",
      "export_success": "Archivo exportado correctamente",
      "export_error": "Error al exportar facturas a PDF"
    }
  },
  "client-invoice-transport-detail": {
    "title": "Detalle transporte",
    "no_data_warning": "Sin datos",
    "no_data_warning_subtitle": "No se han encontrado datos para este transporte",
    "price": {
      "title": "Precio",
      "transport": "Precio transporte (SIN IVA)",
      "fuel": "Combustible (SIN IVA)",
      "ferry": "Ferry (SIN IVA)",
      "electric_charge": "Carga eléctrica (SIN IVA)"
    },
    "additional_costs": {
      "title": "Gastos adicionales",
      "type": "Tipo de gasto adicional",
      "amount": "Precio sin IVA",
      "no_data": "No hay gastos adicionales"
    },
    "cancellation": {
      "title": "Cancelación",
      "penalty": "Penalización por cancelación",
      "cancelled_by": "Quien ha cancelado",
      "reason": "Motivo cancelación"
    },
    "dates": {
      "title": "Fechas",
      "pickup": "Recogida conductor",
      "delivery": "Entrega Conductor"
    },
    "summary": {
      "base_amount": "BASE IMPONIBLE",
      "vat": "IVA",
      "total": "TOTAL A EMITIR"
    }
  },
  "addresses": {
    "title": "Direcciones",
    "back": "Atrás",
    "list": {
      "searchPlaceholder": "Buscar direcciones...",
      "address": "Dirección",
      "type": "Tipo",
      "schedule": "Horario",
      "entity": "Entidad/Subentidad",
      "name": "Nombre",
      "email": "Correo",
      "phone": "Teléfono",
      "actions": "Acciones",
      "address-type": "Tipo dirección",
      "entity-filter": "Entidad",
      "contact-name": "Nombre de contacto",
      "contact-email": "Correo de contacto",
      "contact-phone": "Teléfono de contacto",
      "subentity": "Subentidad",
      "create": "Crear nueva dirección"
    },
    "edit": {
      "title": "Editar dirección"
    },
    "create": {
      "title": "Nueva dirección"
    },
    "editor": {
      "days": {
        "mon": "lun",
        "tue": "mar",
        "wed": "mié",
        "thu": "jue",
        "fri": "vie",
        "sat": "sáb",
        "sun": "dom"
      },
      "time-range": "Franja horaria",
      "add": "AÑADIR",
      "add-time-slot-card": "AÑADIR FRANJA HORARIA",
      "contacts-title": "Contactos",
      "main-contact": "Contacto principal",
      "notify-email": "Notificar al correo de contacto cuando se vaya a recoger o entregar un transporte a la dirección.",
      "overwrite-contact": "Sobrescribir contacto",
      "main": "Principal",
      "actions": "Acciones",
      "yes": "Sí",
      "no": "No",
      "save": "GUARDAR",
      "pickup-title": "Dirección de recogida",
      "name": "Nombre",
      "address-type": "Tipo de dirección",
      "country": "País",
      "province": "Provincia",
      "city": "Ciudad",
      "postal-code": "Código postal",
      "address": "Dirección",
      "address-complement": "Dirección complementaria",
      "entity": "Entidad",
      "subentity": "Subentidad",
      "contact-name": "Nombre de contacto",
      "contact-email": "Correo de contacto",
      "contact-phone": "Teléfono de contacto",
      "schedule-title": "Horario de atención",
      "pickup-contact-title": "Contacto de Recogida",
      "delivery-contact-title": "Contacto de Entrega",
      "intermediate-contact-title": "Contacto etapa intermedia",
      "final-delivery-contact-title": "Contacto de Entrega Final",
      "errors": {
        "name-required": "Nombre obligatorio",
        "phone-required": "Teléfono obligatorio",
        "email-notification-required": "El email es obligatorio"
      }
    },
    "errors": {
      "title_required": "El nombre de la dirección es requerido",
      "street_address_required": "La dirección es requerida",
      "city_required": "La ciudad es requerida",
      "province_required": "La provincia es requerida",
      "postal_code_required": "El código postal es requerido",
      "country_required": "El país es requerido",
      "address_type_required": "El tipo de dirección es requerido",
      "entity_required": "La entidad es requerida",
      "opening_hours_required": "Debe definir al menos una franja horaria para los días seleccionados",
      "one_contact_required": "Al menos un contacto es obligatorio",
      "main_contact_required": "Debe seleccionar un contacto principal",
      "fix_errors": "Por favor, corrija los errores antes de guardar",
      "delete_error_title": "Error",
      "delete_error_message": "No se ha podido eliminar la dirección"
    },
    "delete_confirm_title": "Borrar dirección",
    "delete_confirm_message": "¿Está seguro de que desea borrar la dirección actual?"
  },
  "users-entities": {
    "title": "Usuarios de Entidad",
    "list": {
      "name": "Nombre",
      "lastname": "Apellidos",
      "email": "Email",
      "entity": "Entidad",
      "subentity": "Subentidad",
      "phone": "Teléfono",
      "actions": "Acciones",
      "searchPlaceholder": "Buscar..."
    },
    "filters": {
      "name": "Nombre",
      "lastname": "Apellidos",
      "email": "Correo",
      "phone": "Teléfono",
      "entity": "Entidad",
      "subentity": "Subentidad"
    },
    "actions": {
      "create": "Crear nuevo usuario de entidad",
      "edit": "Editar",
      "delete": "Eliminar"
    },
    "messages": {
      "delete_confirm": "¿Estás seguro de que deseas eliminar este usuario de entidad?",
      "delete_success": "Usuario de entidad eliminado correctamente",
      "delete_error": "Error al eliminar el usuario de entidad"
    },
    "editor": {
      "error-password-required": "La contraseña es obligatoria",
      "title": "Editar cliente/entidad",
      "title-new": "Crear nuevo usuario de entidad",
      "is-superadmin": "Administrador",
      "name": "Nombre",
      "lastname": "Apellidos",
      "email": "Correo",
      "phone": "Teléfono",
      "password": "Contraseña",
      "generate-password": "Crear contraseña segura",
      "client-group": "Grupo cliente",
      "select-entities-subentities": "Seleccionar entidades y subentidades",
      "add-main-client": "Añadir cliente principal",
      "subentity": "Subentidad",
      "entities": "Entidad",
      "subentities": "Subentidades",
      "add": "Añadir",
      "entities-subentities": "Entidades/Subentidades",
      "assign-main-entity": "ASIGNAR A ENTIDAD PRINCIPAL",
      "assign-subentity": "ASIGNAR A SUBENTIDAD",
      "billing-accounts": "Cuentas facturación",
      "notifications": "Mis notificaciones",
      "new-transport-notification": "Notificación email transporte creado",
      "driver-assigned-notification": "Notificación email conductor asignado",
      "transport-finished-notification": "Notificación email transporte finalizado",
      "cancelled-transport-notification": "Notificación email transporte cancelado",
      "other-emails": "Otros correos",
      "other-emails-description": "Escribe aqui la dirección de correo para enviar las notificaciones seleccionadas.",
      "other-emails-placeholder": "Escribe un correo y presiona Enter",
      "other-emails-hint": "Cada correo añadido se mostrará como etiqueta.",
      "save-changes": "Guardar cambios",
      "cancel": "Cancelar",
      "no-entities-selected": "Debe seleccionar al menos una entidad o subentidad.",
      "no-subentities": "No se han seleccionado subentidades asociadas a esta entidad.",
      "no-entities": "No se ha seleccionado la entidad asociada a las subentidades seleccionadas",
      "error-at-least-one-entity": "Debes agregar al menos una entidad (principal) o subentidad antes de guardar.",
      "error-invalid-email": "El email no es válido."
    }
  },
  "statics-page": {
    "construction-title": "Página en construcción",
    "construction-subtitle": "¡Estamos trabajando para mejorar esta sección!",
    "noauth-title": "No está autorizado para entrar en esta ruta",
    "notexist-title": "Página inexistente",
    "notexist-description": "La página que buscas no existe o ha sido eliminada.",
    "back-to-dashboard": "Volver al inicio",
    "duplicate-tab-title": "Pestaña duplicada",
    "duplicate-tab-description": "Ya tienes una sesión abierta en otra pestaña. Cierra esa pestaña para continuar."
  },
  "transportPrincipalType": {
    "SIMPLE_MOVEMENT": "Movimiento simple",
    "PICKUP_TO_FINAL_CUSTOMER": "Recogida a cliente final",
    "DELIVERY_TO_FINAL_CUSTOMER": "Entrega a cliente final",
    "PICKUP_AND_DELIVERY_TO_FINAL_CUSTOMER": "Recogida y entrega a cliente final",
    "WITH_STOPOVER": "Con parada"
  },
  "transportStatus": {
    "PENDING": "Pendiente",
    "PLANIFIED": "Planificado",
    "IN_COURSE": "En curso",
    "FINISHED": "Finalizado",
    "CANCELLED": "Cancelado",
    "DELETED": "Eliminado",
    "EXPIRED": "Expirado",
    "DELIVERED": "Entregado",
    "COLLECTED": "Recogido",
    "IN_STOPOVER": "En parada intermedia",
    "UNASSIGNED": "Anulado"
  },
  "cancelledReason": {
    "VEHICLE_NOT_AVAILABLE": "Vehículo no disponible",
    "VEHICLE_NOT_READY_AT_DEPARTURE": "Vehículo no listo en salida",
    "VEHICLE_NOT_WORKING": "Vehículo averiado",
    "MISSING_MANDATORY_SAFETY_EQUIPMENT": "Falta equipamiento de seguridad",
    "INCORRECT_LICENSE_PLATE": "Matrícula incorrecta",
    "BREAKDOWN_DURING_TRANSPORT": "Avería durante el transporte",
    "ACCIDENT_DURING_TRANSPORT": "Accidente durante el transporte",
    "VEHICLE_REJECTED_AT_ARRIVAL": "Vehículo rechazado al llegar",
    "VEHICLE_REJECTED_NO_APPOINTMENT_AT_DEPOT": "Vehículo rechazado sin cita en depósito",
    "RETURN_REJECTED": "Devolución rechazada",
    "END_CUSTOMER_REQUEST": "Solicitud cliente final",
    "CUSTOMER_REQUEST": "Solicitud cliente",
    "CANCELLATION_DUE_TO_DRIVER_RESERVATION_CANCELLED": "Cancelación por reserva de conductor anulada",
    "RETURN_CANCELLED_DUE_TO_OUTBOUND_CANCELLATION": "Devolución cancelada por anulación de salida",
    "CONTACT_ABSENT_AT_DEPARTURE": "Contacto ausente en salida",
    "CONTACT_ABSENT_AT_ARRIVAL": "Contacto ausente en llegada",
    "UNREACHABLE_CONTACT_AT_START": "Contacto inubicable al inicio",
    "UNREACHABLE_CONTACT_AT_ARRIVAL": "Contacto inubicable en llegada",
    "NO_APPOINTMENT_POSSIBLE_WITH_END_CUSTOMER": "No es posible cita con cliente final",
    "NO_APPOINTMENT_WITH_ARRIVAL_CONTACT": "Sin cita con contacto de llegada",
    "DUPLICATE": "Duplicado",
    "INCORRECT_PICKUP_ADDRESS": "Dirección de recogida incorrecta",
    "INCORRECT_DELIVERY_ADDRESS": "Dirección de entrega incorrecta",
    "NON_COMPLIANT_TRANSPORT_REQUEST": "Solicitud de transporte no conforme",
    "CANCELLATION_DUE_TO_CAPACITY": "Cancelación por capacidad",
    "OTHER": "Otro"
  },
  "legPointType": {
    "ORIGIN": "Origen",
    "STOPOVER": "Escala",
    "STAGE": "Etapa",
    "DESTINATION": "Destino"
  },
  "connectionType": {
    "STOPOVER": "Parada",
    "STAGE": "Etapa"
  },
  "clientType": {
    "DEALERSHIP": "Concesionario",
    "RENTING": "Renting",
    "LEASING": "Leasing",
    "CAR_RENTAL": "Alquiler de coches",
    "CAR_TRADING": "Compraventa",
    "FLEET": "Flota",
    "COMPANY": "Empresa"
  },
  "billingType": {
    "MANUAL": "Manual",
    "AUTOMATIC": "Automático",
    "BY_FINISHED_TRANSPORT": "Por transporte finalizado"
  },
  "clientOrigin": {
    "PROSPECTING": "Prospección",
    "REFERRAL": "Referencia",
    "MARKETING": "Marketing",
    "INBOUND_REQUEST": "Solicitud entrante",
    "OTHERS": "Otros",
    "UNDEFINED": "Indefinido",
    "EVENT": "Evento"
  },
  "requestType": {
    "TRANSPORT": "Transporte",
    "TOLL": "Peaje",
    "FUEL": "Combustible",
    "MEALS": "Comidas",
    "LODGING": "Alojamiento",
    "WAITING_TIME": "Tiempo de espera",
    "ELECTRIC_VEHICLE_CHARGING_TIME": "Carga eléctrica",
    "OTHER": "Otro"
  },
  "requestStatus": {
    "NEW": "Nuevo",
    "PENDING_TICKET_UPLOAD": "Pendiente de ticket",
    "PENDING_VALIDATION": "Pendiente de validación",
    "VALIDATED": "Validado",
    "REQUEST_REJECTED": "Solicitud rechazada",
    "TICKET_REJECTED": "Ticket rechazado"
  },
  "pricingType": {
    "FIXED": "Fijo",
    "PER_KM": "Por km"
  },
  "adjustmentType": {
    "BONUS": "Bonificación",
    "PENALTY": "Penalización"
  },
  "adjustmentOrigin": {
    "INCIDENCE": "Incidencia",
    "OTHER": "Otro",
    "TRANSPORT": "Transporte",
    "UNASSIGNATION": "Desasignación"
  },
  "adjustmentReason": {
    "DOCUMENTATION_INVENTORY": "Documentación / Inventario",
    "PUNCTUALITY": "Puntualidad",
    "WRONG_DELIVERY": "Entrega incorrecta / abandono",
    "FUEL": "Combustible",
    "ADDITIONAL_SERVICES": "Servicios complementarios",
    "EXCESS_KILOMETERS": "Exceso de kilómetros",
    "BEHAVIOR_APPEARANCE": "Comportamiento / Imagen",
    "DAMAGES": "Siniestro / Daños",
    "FINE": "Multa",
    "BILLING": "Facturación / gastos",
    "OPERATIONS_PROCESS": "Proceso operativo",
    "FRAUD": "Fraude",
    "DRIVER_RECOGNITION": "Felicitación",
    "UNASSIGNATION": "Desasignación",
    "OTHER": "Otro"
  },
  "adjustmentSubType": {
    "ADDITIONAL_SERVICES_OTHER": "Otro",
    "BAD_DRESSING": "Vestimenta no adecuada",
    "BAD_TREATMENT": "Trato incorrecto",
    "BEHAVIOR_OTHER": "Otro",
    "BILL_FAKE_RECEIPT": "Recibos falsos",
    "BILL_OTHER": "Otro gasto o irregularidad",
    "BRIEFING_NOT_DONE": "Entrega explicada no realizada",
    "BROKEN_GLASS": "Rotura de luna",
    "CLEANING_INCOMPLETE": "Limpieza incompleta",
    "DAMAGE_EXTERNAL": "Daño exterior",
    "DAMAGE_INTERNAL": "Daño interior",
    "DAMAGE_OTHER": "Otro",
    "DELIVERY_INSTRUCTIONS_IGNORED": "Instrucciones de entrega no seguidas",
    "DOC_INCOMPLETE": "Documentación incompleta",
    "DOC_INVALID": "Documento incorrecto o no válido",
    "DOC_NOT_SENT": "Documentación no enviada",
    "DOC_OTHER": "Otro problema de documentación",
    "DRIVER_RECOGNITION": "Felicitación",
    "EXTRA_DISTANCE": "Distancia adicional (km)",
    "FINE_OTHER": "Otra sanción",
    "FINE_PARKING": "Estacionamiento",
    "FINE_SPEED": "Velocidad",
    "FINE_TOLL": "Peaje o acceso restringido",
    "FRAUD_FAKE_BREAKDOWN": "Avería falsa/no existente",
    "FRAUD_FAKE_DOCUMENT": "Documentación falsificada",
    "FRAUD_FAKE_JUSTIFICATION": "Justificante falso",
    "FUEL_INCOHERENT": "Consumo incoherente con el trayecto",
    "FUEL_LOW_LEVEL": "Nivel inferior al esperado",
    "FUEL_NO_DASH_PHOTO": "Foto del cuadro no aportada",
    "FUEL_OTHER": "Otro",
    "INAPPROPRIATE_COMMENTS": "Comentarios inapropiados",
    "INVENTORY_INCOMPLETE": "Fotos o inventario incompleto",
    "KM_EXCEEDED": "Km excedidos respecto a los previstos",
    "MISUSE": "Uso indebido del vehículo",
    "OP_MISSION_NOT_CLOSED": "Falta cierre de misión",
    "OP_NO_COMMUNICATION": "No comunicación de incidencia",
    "OP_NO_RESPONSE": "No respuesta en siniestro/avería/emergencia",
    "OP_OTHER": "Otro",
    "OP_UNREPORTED_CHANGES": "Modificación sin avisar",
    "OTHER_GENERAL": "Otro",
    "PUBLIC_ROAD": "Vehículo en vía pública",
    "PUNCTUALITY_DELAY": "Retraso/adelanto (con horas)",
    "SERVICE_NOT_PERFORMED": "Servicio no realizado según lo solicitado",
    "SIGNATURE_MISSING": "Firma/validación ausente",
    "TIRE_PUNCTURE": "Pinchazo / llanta",
    "UNAUTHORIZED_AREA": "Aparcado en zona no autorizada",
    "UNPROFESSIONAL": "Falta de profesionalidad",
    "WASH_NOT_DONE": "Lavado no realizado",
    "WRONG_DELIVERY_OTHER": "Otro",
    "WRONG_FUEL": "Error de combustible",
    "WRONG_LOCATION": "Vehículo fuera del punto acordado",
    "WRONG_PERSON": "No entregado a la persona correspondiente"
  },
  "validation": {
    "image": {
      "invalid_jpg_png_gif": "Tipo de archivo no válido. Solo se permiten imágenes (JPG, PNG, GIF)."
    }
  },
  "certification": {
    "title_placeholder": "Título certificación",
    "empty_category": "No hay certificaciones disponibles en esta categoría",
    "select_clients_prompt": "Para ver las certificaciones, selecciona uno o más clientes del listado superior"
  },
  "documents": {
    "empty_category": "No hay documentos disponibles en esta categoría",
    "no_related": "Sin documentos relacionados"
  },
  "regulation": {
    "type": {
      "unassign": "Desasignación",
      "regulation": "Regularización"
    },
    "status": {
      "billed": "Facturado"
    }
  },
  "footer": {
    "cookies": "Cookies",
    "privacy": "Privacidad",
    "terms_conditions": "Términos y condiciones"
  },
  "reasonType": {
    "MISSING_DOCUMENT": "Falta documento",
    "FINE_MANAGEMENT": "Gestión de multa",
    "ACCIDENT_MANAGEMENT": "Gestión de accidente",
    "ADDITIONAL_SERVICE": "Servicio adicional",
    "INAPPROPRIATE_BEHAVIOR": "Comportamiento inapropiado",
    "UNPROFESSIONAL_DRESS": "Vestimenta inadecuada",
    "NOT_RESPECT_PROCESS": "No respeta proceso",
    "PUNCTUALITY_LESS_4H": "Impuntualidad <4h",
    "PUNCTUALITY_MORE_4H": "Impuntualidad >4h",
    "PUNCTUALITY_MORE_1D": "Impuntualidad >1d",
    "FALSE_JUSTIFICATIONS": "Justificaciones falsas",
    "SERVICE_NOT_COMPLETED": "Servicio no completado",
    "SERVICE_NOT_CERTIFIED": "Servicio no certificado",
    "OTHER": "Otro"
  },
  "invoiceStatus": {
    "PENDING_DRIVER": "Pendiente conductor",
    "PENDING_PAYMENT": "Pendiente de pago",
    "PAID": "Pagado"
  },
  "anomalyType": {
    "SCRATCH": "Arañazo",
    "DENT": "Abolladura",
    "BREAK": "Rotura",
    "CHIP": "Impacto / Picada",
    "MISSING_ITEM": "Faltante",
    "POOR_CONDITION": "Mal estado",
    "DIRTY": "Sucio",
    "DESCRIPTION": "Descripción",
    "OTHER": "Otras"
  },
  "anomalyCategory": {
    "BODYWORK": "Carrocería",
    "GLASS": "Lunas / Cristales",
    "INTERIOR": "Interior",
    "OTHER": "Otros"
  },
  "incidenceType": {
    "ALL": "Todas",
    "PUNCTUALITY": "Impuntualidad",
    "EXCESS_KILOMETERS": "Exceso de km",
    "INVENTORY_MISSING": "Falta inventario",
    "INVENTORY_INCOMPLETE": "Inventario incompleto",
    "DRIVER_BEHAVIOR": "Comportamiento conductor",
    "DRIVER_APPEARANCE": "Apariencia conductor",
    "DRIVER_CONGRATULATIONS": "Felicitación conductor",
    "OTHER": "Otro",
    "DOCUMENT_MISSING": "Falta documento",
    "DOCUMENT_BLURRED": "Documento borroso",
    "DOCUMENT_INCOMPLETE": "Documento incompleto",
    "DOCUMENT_INCORRECT": "Documento incorrecto",
    "CLIENT_PROTOCOL_FUEL": "Protocolo cliente: combustible",
    "CLIENT_PROTOCOL_CUSTOMER_CONTACT": "Protocolo cliente: contacto",
    "CLIENT_PROTOCOL_SC_ADDITIONAL_SERVICE": "Protocolo cliente: serv. adicional",
    "CLIENT_PROTOCOL_SC_WASH": "Protocolo cliente: lavado",
    "CLIENT_PROTOCOL_SC_VEHICLE_PRESENTATION": "Protocolo cliente: presentación",
    "CLIENT_PROTOCOL_OTHER": "Protocolo cliente: otro",
    "INCIDENCE_OTHER_OR_MULTIPLE": "Otra o múltiple",
    "INCIDENCE_THEFT_SUSPICION": "Sospecha de robo",
    "INCIDENCE_BODYWORK_DAMAGE": "Daño carrocería",
    "INCIDENCE_GLASS_BREAKAGE": "Rotura cristal",
    "INCIDENCE_FLAT_TIRE": "Pinchazo",
    "INCIDENCE_WRONG_FUEL": "Combustible erróneo",
    "INCIDENCE_INTERIOR_DAMAGE": "Daño interior",
    "FINE_OVERSPEED": "Multa por velocidad",
    "FINE_TOLL": "Multa peaje",
    "FINE_UNPAID_PARKING": "Multa parking",
    "FINE_OTHER": "Multa otra",
    "FINE_TRAFFIC_CODE": "Multa código tráfico",
    "BILLING_FAKE_RECEIPTS": "Facturas falsas",
    "INTERNAL_PROTOCOL_EMERGENCY_CONTACT": "Protocolo interno: emergencia",
    "INTERNAL_PROTOCOL_WARNING_NOTE": "Protocolo interno: aviso",
    "INTERNAL_PROTOCOL_30_MIN_WAIT": "Protocolo interno: espera 30min",
    "INTERNAL_PROTOCOL_UNREPORTED_CHANGES": "Protocolo interno: cambios no reportados",
    "INTERNAL_PROTOCOL_MISSION_NOT_COMPLETED": "Protocolo interno: misión no completada",
    "INTERNAL_PROTOCOL_OTHER": "Protocolo interno: otro"
  },
  "incidenceMainType": {
    "DOCUMENTATION_INVENTORY": "Documentación / Inventario",
    "PUNCTUALITY": "Puntualidad",
    "WRONG_DELIVERY": "Entrega incorrecta / abandono",
    "FUEL": "Combustible",
    "ADDITIONAL_SERVICES": "Servicios complementarios",
    "EXCESS_KILOMETERS": "Exceso de kilómetros",
    "BEHAVIOR_APPEARANCE": "Comportamiento / Imagen",
    "DAMAGES": "Siniestro / Daños",
    "FINE": "Multa",
    "BILLING": "Facturación / gastos",
    "OPERATIONS_PROCESS": "Proceso operativo",
    "FRAUD": "Fraude",
    "DRIVER_RECOGNITION": "Felicitación",
    "OTHER": "Otro"
  },
  "incidenceSubType": {
    "ADDITIONAL_SERVICES_OTHER": "Otro",
    "BAD_DRESSING": "Vestimenta no adecuada",
    "BAD_TREATMENT": "Trato incorrecto",
    "BEHAVIOR_OTHER": "Otro",
    "BILL_FAKE_RECEIPT": "Recibos falsos",
    "BILL_OTHER": "Otro gasto o irregularidad",
    "BRIEFING_NOT_DONE": "Entrega explicada no realizada",
    "BROKEN_GLASS": "Rotura de luna",
    "CLEANING_INCOMPLETE": "Limpieza incompleta",
    "DAMAGE_EXTERNAL": "Daño exterior",
    "DAMAGE_INTERNAL": "Daño interior",
    "DAMAGE_OTHER": "Otro",
    "DELIVERY_INSTRUCTIONS_IGNORED": "Instrucciones de entrega no seguidas",
    "DOC_INCOMPLETE": "Documentación incompleta",
    "DOC_INVALID": "Documento incorrecto o no válido",
    "DOC_NOT_SENT": "Documentación no enviada",
    "DOC_OTHER": "Otro problema de documentación",
    "DRIVER_RECOGNITION": "Felicitación",
    "EXTRA_DISTANCE": "Distancia adicional (km)",
    "FINE_OTHER": "Otra sanción",
    "FINE_PARKING": "Estacionamiento",
    "FINE_SPEED": "Velocidad",
    "FINE_TOLL": "Peaje o acceso restringido",
    "FRAUD_FAKE_BREAKDOWN": "Avería falsa/no existente",
    "FRAUD_FAKE_DOCUMENT": "Documentación falsificada",
    "FRAUD_FAKE_JUSTIFICATION": "Justificante falso",
    "FUEL_INCOHERENT": "Consumo incoherente con el trayecto",
    "FUEL_LOW_LEVEL": "Nivel inferior al esperado",
    "FUEL_NO_DASH_PHOTO": "Foto del cuadro no aportada",
    "FUEL_OTHER": "Otro",
    "INAPPROPRIATE_COMMENTS": "Comentarios inapropiados",
    "INVENTORY_INCOMPLETE": "Fotos o inventario incompleto",
    "KM_EXCEEDED": "Km excedidos respecto a los previstos",
    "MISUSE": "Uso indebido del vehículo",
    "OP_MISSION_NOT_CLOSED": "Falta cierre de misión",
    "OP_NO_COMMUNICATION": "No comunicación de incidencia",
    "OP_NO_RESPONSE": "No respuesta en siniestro/avería/emergencia",
    "OP_OTHER": "Otro",
    "OP_UNREPORTED_CHANGES": "Modificación sin avisar",
    "OTHER_GENERAL": "Otro",
    "PUBLIC_ROAD": "Vehículo en vía pública",
    "PUNCTUALITY_DELAY": "Retraso/adelanto (con horas)",
    "SERVICE_NOT_PERFORMED": "Servicio no realizado según lo solicitado",
    "SIGNATURE_MISSING": "Firma/validación ausente",
    "TIRE_PUNCTURE": "Pinchazo / llanta",
    "UNAUTHORIZED_AREA": "Aparcado en zona no autorizada",
    "UNPROFESSIONAL": "Falta de profesionalidad",
    "WASH_NOT_DONE": "Lavado no realizado",
    "WRONG_DELIVERY_OTHER": "Otro",
    "WRONG_FUEL": "Error de combustible",
    "WRONG_LOCATION": "Vehículo fuera del punto acordado",
    "WRONG_PERSON": "No entregado a la persona correspondiente"
  },
  "incidenceCreator": {
    "ADMIN": "Admin",
    "CLIENT": "Cliente"
  },
  "incidenceStatus": {
    "NEW": "Nueva",
    "PENDING_DRIVER": "Pendiente conductor",
    "PENDING_CLIENT": "Pendiente cliente",
    "PENDING_END_CUSTOMER": "Pendiente cliente final",
    "PENDING_INTERNAL_COLLABORATOR": "Pendiente colaborador interno",
    "PENDING_WORKSHOP": "Pendiente taller",
    "PENDING_INSURANCE": "Pendiente seguro",
    "FINISHED": "Finalizada"
  },
  "severity": {
    "NONE": "Ninguna",
    "LOW": "Baja",
    "MEDIUM": "Media",
    "HIGH": "Alta"
  },
  "responsibility": {
    "DRIVER": "Conductor",
    "FORCE_MAJEURE": "Fuerza mayor",
    "CLIENT": "Cliente",
    "END_CLIENT": "Cliente final",
    "INTERNAL_PROCESS": "Proceso interno",
    "DUPLICATE": "Duplicado",
    "TECHNICAL_ISSUE": "Problema técnico",
    "NOT_APPLICABLE": "No aplica",
    "THIRD_PARTY": "Tercero"
  },
  "protocolType": {
    "SINGLE_CHECK": "Chequeo único",
    "MULTI_CHECK": "Chequeo múltiple",
    "IMAGE": "Imagen"
  },
  "directionType": {
    "ARRIVAL": "Llegada",
    "DEPARTURE": "Salida",
    "BOTH": "Ambos"
  },
  "transportEventType": {
    "CREATED": "Creado",
    "UPDATED": "Actualizado",
    "DRIVER_ASSIGNED": "Conductor asignado",
    "DRIVER_CHANGED": "Conductor cambiado",
    "CLIENT_CANCELED": "Cancelado por cliente",
    "DRIVER_CANCELED": "Cancelado por conductor",
    "CLIENT_APPT_SELECTED": "Cita cliente seleccionada",
    "DRIVER_DATETIME_SET": "Fecha/hora conductor asignada",
    "PICKUP_DONE": "Recogida realizada",
    "DOC_START_UPLOADED": "Doc. inicio subida",
    "DOC_END_UPLOADED": "Doc. fin subida",
    "EXPENSE_TICKET_UPL": "Ticket gasto subido",
    "DELIVERY_DONE": "Entrega realizada",
    "MISSION_FINISHED": "Misión finalizada"
  },
  "driverEventType": {
    "ONBOARD_REGISTERED": "Alta onboard",
    "DOC_UPLOADED": "Doc. subida",
    "DOC_VALIDATED": "Doc. validada",
    "DOC_REJECTED": "Doc. rechazada",
    "PROFILE_UPDATED": "Perfil actualizado",
    "QUOTE_SENT": "Presupuesto enviado",
    "QUOTE_REJECTED": "Presupuesto rechazado",
    "TRANSPORT_ASSIGNED": "Transporte asignado",
    "EXTRA_EXPENSE_REQUESTED": "Gasto extra solicitado",
    "EXTRA_EXPENSE_ACCEPTED": "Gasto extra aceptado",
    "EXTRA_EXPENSE_REJECTED": "Gasto extra rechazado",
    "TICKET_UPLOADED": "Ticket subido",
    "TICKET_ACCEPTED": "Ticket aceptado",
    "TICKET_REJECTED": "Ticket rechazado",
    "QUALITY_ISSUE_REPORTED": "Incidencia calidad reportada"
  },
  "incidenceEventType": {
    "OPENED": "Abierta",
    "COMMENT_ADDED": "Comentario añadido",
    "STATUS_CHANGED": "Estado cambiado",
    "UPDATED": "Actualización de cualquier campo de la incidencia"
  },
  "documentType": {
    "front_dni": "DNI anverso",
    "back_dni": "DNI reverso",
    "front_driving_license": "Carnet conducir anverso",
    "back_driving_license": "Carnet conducir reverso",
    "self_employment_registration_fee": "Alta autónomo",
    "bank_account_certificate": "Certificado cuenta bancaria",
    "criminal_record_certificate": "Certificado penales",
    "driving_points_certificate": "Certificado puntos",
    "self_employment_payment_certificate": "Pago autónomo",
    "tax_census_registration_certificate": "Alta censo fiscal",
    "form_036": "Modelo 036",
    "reta_registration_resolution": "Resolución alta RETA",
    "social_security_compliance_certificate": "Certificado SS",
    "tax_debt_certificate": "Certificado deuda fiscal",
    "residence_permit_nie": "Permiso residencia NIE",
    "work_permit_nie": "Permiso trabajo NIE"
  },
  "incidenceSeverity": {
    "LOW": "Baja",
    "MEDIUM": "Media",
    "HIGH": "Alta",
    "CRITICAL": "Crítica"
  },
  "certificationStatus": {
    "passed": "Aprobado",
    "revoked": "Revocado",
    "manual": "Manual"
  },
  "examQuestionType": {
    "single": "Respuesta única",
    "multiple": "Respuesta múltiple",
    "text": "Texto",
    "boolean": "Sí/No"
  },
  "status": {
    "ACTIVE": "Activo",
    "INACTIVE": "Inactivo",
    "PENDING": "Pendiente",
    "COMPLETED": "Completado",
    "CANCELLED": "Cancelado"
  },
  "priority": {
    "LOW": "Baja",
    "MEDIUM": "Media",
    "HIGH": "Alta",
    "URGENT": "Urgente"
  },
  "notificationType": {
    "SUCCESS": "Éxito",
    "ERROR": "Error",
    "WARNING": "Aviso",
    "INFO": "Info"
  },
  "tagType": {
    "CLIENT": "Cliente",
    "DRIVER": "Conductor",
    "TRANSPORT": "Transporte",
    "INCIDENCE": "Incidencia"
  },
  "sortOrder": {
    "ASC": "Ascendente",
    "DESC": "Descendente"
  },
  "actionType": {
    "CREATE": "Crear",
    "READ": "Leer",
    "UPDATE": "Actualizar",
    "DELETE": "Eliminar"
  },
  "vehicleSize": {
    "SMALL": "Pequeño",
    "MEDIUM": "Mediano",
    "LARGE": "Grande"
  },
  "fuelType": {
    "GASOLINE": "Gasolina",
    "DIESEL": "Diésel",
    "ELECTRIC": "Eléctrico",
    "HYBRID": "Híbrido",
    "PLUG_IN_HYBRID": "Híbrido enchufable",
    "LPG": "GLP",
    "CNG": "GNC",
    "COMBUSTION": "Combustión"
  },
  "bodyType": {
    "SEDAN": "Sedán",
    "COUPE": "Coupé",
    "HATCHBACK": "Hatchback",
    "SUV": "SUV",
    "WAGON": "Familiar",
    "VAN": "Furgoneta",
    "PICKUP": "Pickup",
    "CONVERTIBLE": "Descapotable",
    "MINIVAN": "Monovolumen",
    "ESTATE": "Estate",
    "CHASSIS_CAB_VAN": "Furgoneta",
    "TRUCK": "Furgoneta grande"
  },
  "userRoles": {
    "ADMIN": "Administrador",
    "USER": "Usuario",
    "CLIENT_USER": "Usuario cliente",
    "DRIVER": "Conductor"
  },
  "roleAdmin": {
    "KAM": "KAM",
    "SUPERADMIN": "Superadministrador",
    "OPERATIONS_MANAGER": "Responsable de operaciones",
    "SALES_MANAGER": "Responsable de ventas"
  },
  "userStatus": {
    "ACTIVE": "Activo",
    "INACTIVE": "Inactivo",
    "PENDING": "Pendiente",
    "SUSPENDED": "Suspendido"
  },
  "driverStatus": {
    "AVAILABLE": "Disponible",
    "BUSY": "Ocupado",
    "OFFLINE": "Desconectado",
    "ON_BREAK": "En descanso"
  },
  "driverDocumentCategory": {
    "DNI": "DNI",
    "DRIVING_LICENSE": "Carnet de conducir",
    "DRIVING_POINTS": "Certificado de puntos del carné",
    "SELF_EMPLOYMENT": "Autónomo",
    "BANK_ACCOUNT": "Certificado titularidad bancaria",
    "CRIMINAL_RECORD": "Certificado de antecedentes penales",
    "TAX": "Impuestos",
    "SOCIAL_SECURITY": "Seguridad Social",
    "NIE": "NIE"
  },
  "driverDocumentType": {
    "dni": "DNI",
    "front_dni": "DNI (Anverso)",
    "back_dni": "DNI (Reverso)",
    "driving_license": "Carnet de conducir",
    "front_driving_license": "Carnet de conducir (Anverso)",
    "back_driving_license": "Carnet de conducir (Reverso)",
    "driving_points_certificate": "Certificado de puntos del carné",
    "self_employment_registration_fee": "Alta de autónomo",
    "self_employment_payment_certificate": "Justificante de pago de autónomo",
    "reta_registration_resolution": "Resolución de alta en RETA",
    "bank_account_certificate": "Certificado de titularidad bancaria",
    "criminal_record_certificate": "Certificado de antecedentes penales",
    "tax_census_registration_certificate": "Certificado de alta censal",
    "tax_debt_certificate": "Certificado al corriente con Hacienda",
    "form_036": "Modelo 036",
    "social_security_compliance_certificate": "Certificado al corriente con la Seguridad Social",
    "residence_permit_nie": "Permiso de residencia (NIE)",
    "work_permit_nie": "Permiso de trabajo (NIE)"
  },
  "driverDocumentStatus": {
    "PENDING": "Pendiente",
    "PENDANT": "Pendiente",
    "VALIDATED": "Validado",
    "APPROVED": "Aprobado",
    "REJECTED": "Invalidado",
    "EXPIRED": "Caducado"
  },
  "driverDocumentInvalidationReasonType": {
    "EXPIRED": "Caducado",
    "INVALID": "Inválido",
    "ILLEGIBLE": "Ilegible",
    "INCOMPLETE": "Incompleto",
    "OTHER": "Otro"
  },
  "modals": {
    "multiselection": {
      "title": "Check multiselección",
      "singleCheckTitle": "Chequeo único",
      "addNewOption": "+ AÑADIR NUEVA OPCIÓN",
      "placeholder": "Escriba aquí...",
      "save": "GUARDAR",
      "max_options_exceeded": "Se ha superado el número máximo de opciones permitidas"
    }
  },
  "errors": {
    "sessionExpired": "Sesión expirada",
    "client": {
      "name-required": "El nombre del cliente es obligatorio.",
      "group-required": "El grupo de cliente es obligatorio.",
      "client-type-required": "El tipo de cliente es obligatorio.",
      "principal-client-required": "El cliente principal es obligatorio.",
      "contact-email-invalid": "El email de contacto no es válido.",
      "contact-name-required": "El nombre de la persona de contacto es obligatorio.",
      "cif-required": "El CIF es obligatorio.",
      "invite-delay-required": "El tiempo de retraso de invitación es obligatorio y debe ser mayor que 0.",
      "reminder-interval-required": "El intervalo de recordatorio es obligatorio y debe ser mayor que 0."
    },
    "billing": {
      "email_send_invoice": "El email de facturación es obligatorio.",
      "document_type": "El tipo de documento es obligatorio.",
      "iva": "El IVA es obligatorio.",
      "business_name": "La razón social es obligatoria.",
      "address": "La dirección debe tener al menos 5 caracteress y es obligatoria.",
      "postal_code": "El código postal es obligatorio.",
      "country": "El país es obligatorio.",
      "city": "La ciudad es obligatoria.",
      "phone": "El teléfono es obligatorio.",
      "entity_number": "La referencia de entidad es obligatoria."
    },
    "documents": {
      "type-movement": "El tipo de movimiento es obligatorio.",
      "moment": "El momento es obligatorio",
      "not-file": "Debe seleccionar un archivo o una URL.",
      "confirm-delete-document": "¿Estás seguro de que deseas eliminar este documento?",
      "error-delete-document": "Error al eliminar el documento. Por favor, inténtalo de nuevo."
    }
  },
  "fileUploadType": {
    "URL": "Url",
    "FILE": "Archivo"
  },
  "dropFile": {
    "dropHere": "Suelta el archivo aquí...",
    "dropImage": "Arrastra una imagen aquí o haz clic para seleccionar",
    "dropFile": "Arrastra un fichero o haz click",
    "viewFile": "ver archivo",
    "deleteFile": "Eliminar archivo"
  },
  "EntityDocumentType": {
    "DNI": "DNI",
    "CIF": "CIF",
    "OTHER": "Otro"
  },
  "drivers": {
    "title": "Conductores",
    "create": "Crear nuevo conductor",
    "IVAIRPF": "MODIFICAR IVA / IRPF",
    "tabs": {
      "general-data": "Datos generales",
      "quality": "Calidad",
      "certifications": "Certificaciones",
      "blacklist": "Blacklist",
      "documentation": "Documentación",
      "billing": "Facturación",
      "timeline": "Timeline",
      "authorized": "Autorizados"
    },
    "list": {
      "image": "Foto",
      "name": "Nombre",
      "dni": "DNI",
      "cif": "CIF",
      "dni/cif": "DNI/CIF",
      "province": "Provincia",
      "city": "Ciudad",
      "email": "Correo",
      "phone": "Teléfono",
      "created_datetime": "F. Alta",
      "rating": "Puntuación",
      "tags": "Tags",
      "validated": "Validación",
      "fortnight_earnings": "Factura Quincenal",
      "status": "Estado",
      "actions": "Acciones",
      "searchPlaceholder": "Buscar",
      "is_active": "Estado",
      "expiredDocuments": "Conductores con documentos expirados",
      "newDocuments": "Conductores con nuevos documentos aportados",
      "create-driver": "Crear nuevo conductor",
      "name_filter": "Nombre",
      "email_filter": "Email",
      "tags_filter": "Etiquetas",
      "is_active_filter": "Estado Activo",
      "validated_filter": "Validación",
      "rating_filter": "Puntuación",
      "phone_filter": "Teléfono",
      "city_filter": "Ciudad",
      "province_filter": "Provincia",
      "expiredDocuments_filter": "Conductores con documentos expirados",
      "newDocuments_filter": "Conductores con nuevos documentos aportados"
    },
    "generalData": {
      "uploadPhoto": "Subir foto",
      "removePhoto": "Eliminar foto",
      "photoUploadInfo": "Permite JPG, GIF o PNG. Tamaño Máx. 800K",
      "firstName": "Nombre",
      "firstNameRequired": "El nombre es obligatorio",
      "lastName": "Apellidos",
      "lastNameRequired": "Los apellidos son obligatorios",
      "dniNie": "DNI/NIE",
      "dniNieRequired": "El DNI/NIE es obligatorio",
      "cif": "CIF",
      "businessName": "Razón social",
      "fullAddress": "Dirección completa",
      "postalCode": "Código postal",
      "city": "Ciudad",
      "province": "Provincia",
      "country": "País",
      "selectCountry": "Seleccionar país",
      "email": "Correo electrónico",
      "emailRequired": "El correo electrónico es obligatorio",
      "phone": "Teléfono de contacto",
      "tags": "Tags",
      "isActive": "Activar/Desactivar cuenta",
      "blockMissions": "Bloquear misiones",
      "saveChanges": "Guardar cambios",
      "invalidFileType": "Tipo de archivo no válido. Solo se permiten imágenes (JPG, PNG, WEBP).",
      "fileTooLarge": "El archivo es demasiado grande. El tamaño máximo es 5MB."
    },
    "billing": {
      "iban": "IBAN",
      "bic": "BIC",
      "irpf": "IRPF",
      "biweeklyBilling": "Facturado en la quincena",
      "saveChanges": "GUARDAR CAMBIOS"
    },
    "ivaIrpf": {
      "title": "Modificar IVA/IRPF",
      "ivaApplicado": "IVA aplicado",
      "irpfApplicado": "IRPF aplicado",
      "save": "GUARDAR",
      "saving": "Guardando...",
      "load_error": "Error al cargar los impuestos por defecto",
      "save_error": "Error al guardar los impuestos por defecto",
      "invalid_values": "Los valores deben ser numéricos válidos"
    },
    "blacklist": {
      "createButton": "Crear nueva entrada",
      "loading": "Cargando blacklist...",
      "noData": "No hay entradas en la blacklist",
      "deleteConfirm": "¿Estás seguro de que deseas eliminar esta entrada de la blacklist?",
      "deleteSuccess": "Entrada de blacklist eliminada correctamente",
      "deleteError": "Error al eliminar la entrada de blacklist",
      "delete": {
        "title": "Eliminar entrada de blacklist",
        "confirmation": "¿Estás seguro de que deseas eliminar la entrada para {{clientName}}?",
        "error": "Error al eliminar la entrada de blacklist"
      },
      "columns": {
        "client": "Cliente",
        "movementType": "Tipo de movimiento",
        "subentity": "Subentidad",
        "subentityMovementType": "Tipo de movimiento subentidad",
        "actions": "Acciones"
      },
      "modal": {
        "title": "Incluir lista negra",
        "editTitle": "Editar lista negra",
        "clientLabel": "Cliente",
        "clientPlaceholder": "Seleccione un cliente",
        "movementTypeLabel": "Tipo de movimiento cliente",
        "movementTypePlaceholder": "Seleccione tipo de movimiento",
        "addSubentityButton": "Añadir subentidad",
        "subentityLabel": "Subentidad",
        "subentityPlaceholder": "Seleccione una subentidad",
        "subentityMovementTypeLabel": "Tipo de movimiento",
        "saveButton": "Guardar",
        "cancelButton": "Cancelar",
        "removeSubentityButton": "Eliminar"
      }
    },
    "invalidateDocument": {
      "title": "Invalidar documento",
      "reasonLabel": "Motivo",
      "reasonPlaceholder": "Seleccione un motivo...",
      "messageLabel": "Mensaje",
      "messagePlaceholder": "Escriba un mensaje...",
      "invalidateButton": "Invalidar",
      "errorLoadingReasons": "Error al cargar los motivos de invalidación",
      "fieldsRequired": "Debe seleccionar un motivo y escribir un mensaje",
      "errorInvalidating": "Error al invalidar el documento. Inténtelo de nuevo",
      "reasons": {
        "EXPIRED": "Documento caducado",
        "ILLEGIBLE": "Documento ilegible",
        "INVALID": "Documento incorrecto",
        "INCOMPLETE": "Documento incompleto",
        "OTHER": "Otro"
      }
    },
    "validateDocument": {
      "expirationDateRequired": "Debe introducir una fecha de caducidad antes de validar el documento",
      "errorValidating": "Error al validar el documento. Inténtelo de nuevo",
      "errorSavingDate": "Error al guardar la fecha de caducidad. Inténtelo de nuevo"
    },
    "authorized": {
      "loading": "Cargando autorizados...",
      "noData": "No hay conductores autorizados",
      "columns": {
        "name": "Nombre",
        "email": "Correo",
        "phone": "Teléfono",
        "dni": "DNI"
      },
      "filters": {
        "name": "Nombre",
        "email": "Correo",
        "phone": "Teléfono",
        "dni": "DNI"
      }
    },
    "quality": {
      "loading": "Cargando incidencias de calidad...",
      "noData": "No hay incidencias de calidad",
      "columns": {
        "incidentType": "Tipo incidencia",
        "client": "Cliente",
        "subentity": "Subentidad",
        "movementType": "Tipo Movimiento",
        "score": "Puntuación",
        "actions": "Acciones"
      },
      "filters": {
        "incidentType": "Tipo incidencia",
        "client": "Cliente",
        "subentity": "Subentidad"
      }
    },
    "timeline": {
      "loading": "Cargando historial...",
      "noData": "No hay eventos registrados",
      "columns": {
        "eventType": "Tipo de evento",
        "dateTime": "Fecha y hora",
        "actionType": "Tipo de acción",
        "user": "Usuario",
        "observations": "Observaciones"
      }
    },
    "profile": {
      "ACTIVE": "Activo",
      "INACTIVE": "Inactivo",
      "VALIDATE": "Validado",
      "NO_VALIDATE": "Pendiente",
      "EXPIRED": "Caducados",
      "NO_EXPIRED": "Sin Caducar",
      "NEW_DOCUMENT": "Documento Nuevo",
      "NO_NEW_DOCUMENT": "Sin Documento Nuevo"
    },
    "isActive": {
      "ACTIVE": "Activo",
      "INACTIVE": "Inactivo"
    },
    "actions": {
      "edit": "Editar",
      "view": "Ver",
      "delete": "Eliminar"
    },
    "messages": {
      "no_data": "No hay conductores disponibles",
      "loading": "Cargando conductores...",
      "delete_confirm": "¿Estás seguro de que deseas eliminar este conductor?",
      "delete_success": "Conductor eliminado correctamente",
      "delete_error": "Error al eliminar el conductor, puede que tenga transportes activos"
    }
  },
  "additionalServices": {
    "applyment-moments": {
      "PICKUP": "Recogida",
      "DROPOFF": "Entrega",
      "PICKUP_AND_DROPOFF": "Recogida y entrega",
      "IN_COURSE": "En curso",
      "STOPOVER": "Parada",
      "ALL": "Todos"
    }
  },
  "addressType": {
    "CRANE_DEPOT": "Depósito de grúa",
    "DEALERSHIP": "Concesionario",
    "ITV": "ITV",
    "PRIVATE": "Privado",
    "REPAIR_SHOP": "Taller",
    "VEHICLE_YARD": "Campa",
    "WAREHOUSE": "Almacén"
  },
  "confirmMessages": {
    "RengeKm": "¿Estás seguro de que deseas eliminar este tramo de distancia?",
    "deleteBilling": "¿Estás seguro de que deseas eliminar cuenta de facturación?",
    "DeleteTransport": "¿Confirma en eliminar el transporte?"
  },
  "generalLabels": {
    "option": "Opción"
  },
  "errorsGlobal": {
    "required-field": "Este campo es obligatorio",
    "element-cant-not-delete": "El elemento no se puede eliminar",
    "import-error": "Error en formato o no hay datos que importar"
  },
  "assign-notifications-modal": {
    "title": "Asignar notificaciones",
    "searchPlaceholder": "Buscar usuarios",
    "save": "Guardar",
    "noUsers": "No hay usuarios asignados a esta entidad.",
    "noResults": "No se encontraron usuarios con ese criterio de búsqueda.",
    "notifications": {
      "driver-assigned": "Notificación email conductor asignado",
      "transport-finished": "Notificación email transporte finalizado",
      "transport-created": "Notificación email transporte creado",
      "transport-cancelled": "Notificación email transporte cancelado"
    }
  },
  "popup": {
    "confirm": "CONFIRMAR",
    "continue": "CONTINUAR",
    "accept": "ACEPTAR",
    "cancel": "CANCELAR"
  },
  "quality-management": {
    "title": "Gestión info calidad",
    "list": {
      "searchPlaceholder": "Buscar incidencias...",
      "type": "Tipo",
      "mission_id": "ID Misión",
      "entity_sub": "Entidad / SUB",
      "opening_date": "F. Apertura",
      "update_date": "F. Actualización",
      "driver": "Conductor",
      "status": "Estado",
      "responsible": "Responsable",
      "origin": "Origen",
      "origin_admin": "Administrador",
      "origin_client": "Cliente",
      "actions": "Acciones"
    },
    "filters": {
      "driver": "Conductor",
      "entity": "Entidad",
      "subentity": "Subentidad",
      "opening_date": "Fecha apertura",
      "update_date": "Fecha actualización",
      "incident_type": "Tipo de incidencia",
      "status": "Estado",
      "mission_id": "ID Misión",
      "origin": "Origen",
      "responsible": "Responsable",
      "city": "Ciudad",
      "country": "País"
    },
    "actions": {
      "edit": "Editar",
      "delete": "Eliminar",
      "delete_confirm_title": "¿Eliminar incidencia?",
      "delete_confirm_message": "¿Está seguro de que desea eliminar esta incidencia de calidad?"
    }
  },
  "incident-management": {
    "title": "Gestionar incidencia",
    "created-by": "Creada por:",
    "date-time": "Fecha y hora:",
    "incident-details": "Detalles de la incidencia",
    "type": "Tipo",
    "mission-id": "ID Misión",
    "client": "Cliente",
    "driver": "Conductor",
    "status": "Estado",
    "responsible": "Responsable",
    "noData": "No hay datos",
    "content-placeholder": "Contenido de gestión de incidencia próximamente",
    "incident-tab-placeholder": "Contenido de gestión de incidencia próximamente",
    "metrics-tab-placeholder": "Contenido de métricas próximamente",
    "save-changes": "Guardar cambios",
    "timeline": {
      "title": "Timeline incidencia",
      "modified-by": "Modificada por:",
      "add-comment": "Añadir comentario"
    },
    "blacklist": {
      "title": "Clientes lista negra"
    },
    "incident-data": {
      "title": "Datos de la incidencia",
      "comment": "Comentario",
      "attachments": "Adjuntos"
    },
    "tickets": {
      "title": "Tickets de contacto",
      "client-link": "Enlace con cliente",
      "driver-link": "Enlace con conductor",
      "save": "Guardar",
      "icon-link": "Icono link"
    },
    "settings": {
      "title": "Ajustes sobre la incidencia",
      "admin-responsable": "Administrador responsable",
      "status": "Estado",
      "reason": "Motivo",
      "sub-reason": "Submotivo",
      "quantity": "Cantidad (Km / Horas / Litros...)",
      "responsibility": "Responsabilidad",
      "severity": "Gravedad",
      "severity-note": "Puntuación actual: {{current_rating}}pnts Puntuación a retirar: {{delta}}pnts = Puntuación actual conductor {{new_rating}}pnts",
      "driver-notice": "Preaviso al conductor",
      "exclude-transport-type": "Excluir solo por tipo de movimiento",
      "add-to-blacklist": "Añadir a lista negra cliente",
      "blacklist-warning": "Este conductor ha estado en la lista negra 2 veces"
    },
    "regularization": {
      "title": "Regularización económica",
      "no-action": "No realizar acción",
      "type": "Tipo regularización",
      "driver-message": "Mensaje conductor",
      "write-here": "Escriba aquí...",
      "amount": "Importe",
      "manualEntry": "Introducir manualmente",
      "success": "Transporte cancelado con éxito",
      "enter-manually": "Regularización manual",
      "messages": {
        "delete_title": "Borrado de regularización",
        "delete_confirm": "¿Seguro que quiera eliminar la regularización?",
        "delete_success": "Regularización eliminada correctamente",
        "delete_error": "Error al eliminar la regularizción",
        "invoiced_transport": "No se puede modificar/cancelar una regularización que ya está facturada"
      }
    },
    "metrics": {
      "global-driver-incidents": "Incidencias globales conductor",
      "client-driver-incidents": "Incidencias cliente sobre conductor",
      "global-client-incidents": "Incidencias globales cliente",
      "driver": "Conductor",
      "motivo": "MOTIVO",
      "submotivo": "SUBMOTIVO",
      "cantidad": "CANTIDAD"
    },
    "incidents": {
      "success": {
        "created": "Incidencia creada correctamente",
        "updated": "Incidencia modificada correctamente",
        "deleted": "Incidencia borrada correctamente"
      },
      "errors": {
        "cannot_delete_invoiced_adjustment": "No se puede eliminar un ajuste que tenga facturas asociadas",
        "delete_failed": "No ha podido borrarse la incidencia",
        "message_required": "Ha seleccionado realizar una acción sobre el conductor, no ha informado del mensaje"
      }
    }
  },
  "tooltipsLabels": {
    "base_price": "Precio base",
    "fuel_price": "Combustible",
    "outbound_price": "Precio ida",
    "return_price": "Precio vuelta",
    "ferry": "Ferry",
    "toll": "Peaje",
    "additionals_services": "Servicios adicionales",
    "additionals_costs": "Gastos adicionales",
    "optional_expenses_price": "Gastos opcionales",
    "adjustments": "Regularizaciones",
    "total": "TOTAL"
  }
}
